/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  ActivityFuel,
  ActivityGas,
  ActivityImportBase,
  ActivityImportProgress,
  ActivityImportRetrieveUpdate,
  ActivityUnit,
  ActivityUpdateResponse,
  BusinessTravelActivityRetrieve,
  CCFPackagingGroup,
  CompanyReport,
  CompanyReportCategoryStatus,
  CompanyReportDetail,
  CompanyReportPreviewResults,
  CompanyReportPublishResponse,
  CompanyReportResult,
  CompanyReportsActivitiesBusinessTravelListParams,
  CompanyReportsActivitiesDirectGasEmissionsListParams,
  CompanyReportsActivitiesDirectGasEmissionsPreviewRetrieveParams,
  CompanyReportsActivitiesElectricityListParams,
  CompanyReportsActivitiesElectricityPreviewRetrieveParams,
  CompanyReportsActivitiesFoodListParams,
  CompanyReportsActivitiesFoodPreviewRetrieveParams,
  CompanyReportsActivitiesHeatListParams,
  CompanyReportsActivitiesHeatPreviewRetrieveParams,
  CompanyReportsActivitiesMobileCombustionListParams,
  CompanyReportsActivitiesMobileCombustionPreviewRetrieveParams,
  CompanyReportsActivitiesPackagingListParams,
  CompanyReportsActivitiesPackagingPreviewRetrieveParams,
  CompanyReportsActivitiesStationaryCombustionListParams,
  CompanyReportsActivitiesStationaryCombustionPreviewRetrieveParams,
  CompanyReportsActivitiesSupplyChainLogisticsListParams,
  CompanyReportsActivitiesSupplyChainLogisticsPreviewRetrieveParams,
  CompanyReportsActivityTypesUnitsListParams,
  CompanyReportsFuelsListParams,
  CompanyReportsGasesListParams,
  CompanyReportsImportsListParams,
  CompanyReportsListParams,
  CompanyReportsOtherActivitiesListParams,
  CompanyReportsPassengerTransportModesListParams,
  CompanyReportsSitesElectricitySuppliesListParams,
  CompanyReportsSitesListParams,
  CompanyReportsSupplyChainLogisticsFlowListParams,
  CompanyReportsTransportModesListParams,
  DirectGasEmissionActivityCreate,
  DirectGasEmissionActivityRetrieve,
  DirectGasEmissionActivityUpdate,
  DirectGasEmissionPreviewResults,
  ElectricityActivityCreate,
  ElectricityActivityRetrieve,
  ElectricityActivityUpdate,
  ElectricityPreviewResults,
  ElectricitySupply,
  FoodActivityRetrieveUpdate,
  FoodAndDrinkPreviewResults,
  FuelUsageCreate,
  FuelUsageUpdate,
  HeatActivityCreate,
  HeatActivityPreviewResults,
  HeatActivityRetrieve,
  HeatActivityUpdate,
  ImportConfig,
  LogisticsFlowCreate,
  LogisticsFlowDetail,
  LogisticsFlowTemplate,
  LogisticsFlowUpdate,
  MobileCombustionActivityCreate,
  MobileCombustionActivityRetrieve,
  MobileCombustionActivityUpdate,
  MobileCombustionPreviewResults,
  OtherActivity,
  OtherActivityRetrieve,
  PackagingActivityRetrieve,
  PackagingActivityUpdate,
  PackagingPreviewResults,
  PaginatedActivityImportListList,
  PaginatedBusinessTravelActivitiesListList,
  PaginatedCompanyReportList,
  PaginatedDirectGasEmissionActivitiesListList,
  PaginatedElectricityActivitiesListList,
  PaginatedElectricitySupplyList,
  PaginatedFoodActivitiesListList,
  PaginatedHeatActivitiesListList,
  PaginatedLogisticsFlowListList,
  PaginatedMobileCombustionActivitiesListList,
  PaginatedOtherActivitiesListList,
  PaginatedPackagingActivitiesListList,
  PaginatedSiteList,
  PaginatedStationaryCombustionActivitiesListList,
  PaginatedSupplyChainLogisticsActivitiesListList,
  PaginatedSupplyChainTransportModeList,
  PassengerTransportCreate,
  PassengerTransportMode,
  PassengerTransportUpdate,
  PatchedActivityImportRetrieveUpdate,
  PatchedElectricitySupply,
  PatchedLogisticsFlowDetail,
  PatchedSECRReportConfig,
  PatchedSite,
  ProcessDirectGasEmissionsRows,
  ProcessElectricityRows,
  ProcessHeatRows,
  ProcessMixedRows,
  ProcessMobileCombustionRows,
  ProcessStationaryCombustionRows,
  ReportResultDownload,
  ReportingYear,
  SECRReportConfig,
  SECRReportResult,
  Site,
  StationaryCombustionActivityCreate,
  StationaryCombustionActivityRetrieve,
  StationaryCombustionActivityUpdate,
  StationaryCombustionPreviewResults,
  SupplyChainLogisticsActivityCreate,
  SupplyChainLogisticsPreviewResults,
  Tag,
  TimePeriod,
  TotalEmissionsCreate,
  TotalEmissionsUpdate
} from '../../types'
import { apiClient } from '../../client';

// https://stackoverflow.com/questions/49579094/typescript-conditional-types-filter-out-readonly-properties-pick-only-requir/49579497#49579497
type IfEquals<X, Y, A = X, B = never> = (<T>() => T extends X ? 1 : 2) extends <
T,
>() => T extends Y ? 1 : 2
? A
: B;

type WritableKeys<T> = {
[P in keyof T]-?: IfEquals<
  { [Q in P]: T[P] },
  { -readonly [Q in P]: T[P] },
  P
>;
}[keyof T];

type UnionToIntersection<U> =
  (U extends any ? (k: U)=>void : never) extends ((k: infer I)=>void) ? I : never;
type DistributeReadOnlyOverUnions<T> = T extends any ? NonReadonly<T> : never;

type Writable<T> = Pick<T, WritableKeys<T>>;
type NonReadonly<T> = [T] extends [UnionToIntersection<T>] ? {
  [P in keyof Writable<T>]: T[P] extends object
    ? NonReadonly<NonNullable<T[P]>>
    : T[P];
} : DistributeReadOnlyOverUnions<T>;



type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const companyReportsList = (
    params?: CompanyReportsListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedCompanyReportList>(
      {url: `/company-reports/`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCompanyReportsListQueryKey = (params?: CompanyReportsListParams,) => {
    return [`/company-reports/`, ...(params ? [params]: [])] as const;
    }

    
export const getCompanyReportsListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsList>>, TError = unknown>(params?: CompanyReportsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsList>>> = ({ signal, pageParam }) => companyReportsList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsList>>>
export type CompanyReportsListInfiniteQueryError = unknown

export const useCompanyReportsListInfinite = <TData = Awaited<ReturnType<typeof companyReportsList>>, TError = unknown>(
 params?: CompanyReportsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsListQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsList>>, TError = unknown>(params?: CompanyReportsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsList>>> = ({ signal }) => companyReportsList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsListQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsList>>>
export type CompanyReportsListQueryError = unknown

export const useCompanyReportsList = <TData = Awaited<ReturnType<typeof companyReportsList>>, TError = unknown>(
 params?: CompanyReportsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsCreate = (
    companyReport: NonReadonly<CompanyReport>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<CompanyReport>(
      {url: `/company-reports/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: companyReport
    },
      options);
    }
  


export const getCompanyReportsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsCreate>>, TError,{data: NonReadonly<CompanyReport>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsCreate>>, TError,{data: NonReadonly<CompanyReport>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsCreate>>, {data: NonReadonly<CompanyReport>}> = (props) => {
          const {data} = props ?? {};

          return  companyReportsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsCreate>>>
    export type CompanyReportsCreateMutationBody = NonReadonly<CompanyReport>
    export type CompanyReportsCreateMutationError = unknown

    export const useCompanyReportsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsCreate>>, TError,{data: NonReadonly<CompanyReport>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsCreate>>,
        TError,
        {data: NonReadonly<CompanyReport>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsRetrieve = (
    companyReportUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<CompanyReportDetail>(
      {url: `/company-reports/${companyReportUuid}`, method: 'GET', signal
    },
      options);
    }
  

export const getCompanyReportsRetrieveQueryKey = (companyReportUuid: string,) => {
    return [`/company-reports/${companyReportUuid}`] as const;
    }

    
export const getCompanyReportsRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsRetrieve>>, TError = unknown>(companyReportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsRetrieveQueryKey(companyReportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsRetrieve>>> = ({ signal }) => companyReportsRetrieve(companyReportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsRetrieve>>>
export type CompanyReportsRetrieveInfiniteQueryError = unknown

export const useCompanyReportsRetrieveInfinite = <TData = Awaited<ReturnType<typeof companyReportsRetrieve>>, TError = unknown>(
 companyReportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsRetrieveInfiniteQueryOptions(companyReportUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsRetrieve>>, TError = unknown>(companyReportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsRetrieveQueryKey(companyReportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsRetrieve>>> = ({ signal }) => companyReportsRetrieve(companyReportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsRetrieve>>>
export type CompanyReportsRetrieveQueryError = unknown

export const useCompanyReportsRetrieve = <TData = Awaited<ReturnType<typeof companyReportsRetrieve>>, TError = unknown>(
 companyReportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsRetrieveQueryOptions(companyReportUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsActivitiesDestroy = (
    companyReportUuid: string,
    activityUuid: string,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<void>(
      {url: `/company-reports/${companyReportUuid}/activities/${activityUuid}`, method: 'DELETE'
    },
      options);
    }
  


export const getCompanyReportsActivitiesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesDestroy>>, TError,{companyReportUuid: string;activityUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesDestroy>>, TError,{companyReportUuid: string;activityUuid: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsActivitiesDestroy>>, {companyReportUuid: string;activityUuid: string}> = (props) => {
          const {companyReportUuid,activityUuid} = props ?? {};

          return  companyReportsActivitiesDestroy(companyReportUuid,activityUuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsActivitiesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesDestroy>>>
    
    export type CompanyReportsActivitiesDestroyMutationError = unknown

    export const useCompanyReportsActivitiesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesDestroy>>, TError,{companyReportUuid: string;activityUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsActivitiesDestroy>>,
        TError,
        {companyReportUuid: string;activityUuid: string},
        TContext
      > => {

      const mutationOptions = getCompanyReportsActivitiesDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * List business travel activities under a company report.
 */
export const companyReportsActivitiesBusinessTravelList = (
    companyReportUuid: string,
    params?: CompanyReportsActivitiesBusinessTravelListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedBusinessTravelActivitiesListList>(
      {url: `/company-reports/${companyReportUuid}/activities/business-travel`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCompanyReportsActivitiesBusinessTravelListQueryKey = (companyReportUuid: string,
    params?: CompanyReportsActivitiesBusinessTravelListParams,) => {
    return [`/company-reports/${companyReportUuid}/activities/business-travel`, ...(params ? [params]: [])] as const;
    }

    
export const getCompanyReportsActivitiesBusinessTravelListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelList>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesBusinessTravelListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesBusinessTravelListQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelList>>> = ({ signal, pageParam }) => companyReportsActivitiesBusinessTravelList(companyReportUuid,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesBusinessTravelListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelList>>>
export type CompanyReportsActivitiesBusinessTravelListInfiniteQueryError = unknown

export const useCompanyReportsActivitiesBusinessTravelListInfinite = <TData = Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelList>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesBusinessTravelListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesBusinessTravelListInfiniteQueryOptions(companyReportUuid,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsActivitiesBusinessTravelListQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelList>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesBusinessTravelListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesBusinessTravelListQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelList>>> = ({ signal }) => companyReportsActivitiesBusinessTravelList(companyReportUuid,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesBusinessTravelListQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelList>>>
export type CompanyReportsActivitiesBusinessTravelListQueryError = unknown

export const useCompanyReportsActivitiesBusinessTravelList = <TData = Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelList>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesBusinessTravelListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesBusinessTravelListQueryOptions(companyReportUuid,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Retrieve a single business travel activity.
 */
export const companyReportsActivitiesBusinessTravelRetrieve = (
    companyReportUuid: string,
    activityUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<BusinessTravelActivityRetrieve>(
      {url: `/company-reports/${companyReportUuid}/activities/business-travel/${activityUuid}`, method: 'GET', signal
    },
      options);
    }
  

export const getCompanyReportsActivitiesBusinessTravelRetrieveQueryKey = (companyReportUuid: string,
    activityUuid: string,) => {
    return [`/company-reports/${companyReportUuid}/activities/business-travel/${activityUuid}`] as const;
    }

    
export const getCompanyReportsActivitiesBusinessTravelRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelRetrieve>>, TError = unknown>(companyReportUuid: string,
    activityUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesBusinessTravelRetrieveQueryKey(companyReportUuid,activityUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelRetrieve>>> = ({ signal }) => companyReportsActivitiesBusinessTravelRetrieve(companyReportUuid,activityUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid && activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesBusinessTravelRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelRetrieve>>>
export type CompanyReportsActivitiesBusinessTravelRetrieveInfiniteQueryError = unknown

export const useCompanyReportsActivitiesBusinessTravelRetrieveInfinite = <TData = Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    activityUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesBusinessTravelRetrieveInfiniteQueryOptions(companyReportUuid,activityUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsActivitiesBusinessTravelRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelRetrieve>>, TError = unknown>(companyReportUuid: string,
    activityUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesBusinessTravelRetrieveQueryKey(companyReportUuid,activityUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelRetrieve>>> = ({ signal }) => companyReportsActivitiesBusinessTravelRetrieve(companyReportUuid,activityUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid && activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesBusinessTravelRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelRetrieve>>>
export type CompanyReportsActivitiesBusinessTravelRetrieveQueryError = unknown

export const useCompanyReportsActivitiesBusinessTravelRetrieve = <TData = Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    activityUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesBusinessTravelRetrieveQueryOptions(companyReportUuid,activityUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Update a fuel-usage business travel activity.
 */
export const companyReportsActivitiesBusinessTravelFuelUsageUpdate = (
    companyReportUuid: string,
    activityUuid: string,
    fuelUsageUpdate: NonReadonly<FuelUsageUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ActivityUpdateResponse>(
      {url: `/company-reports/${companyReportUuid}/activities/business-travel/${activityUuid}/fuel-usage`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: fuelUsageUpdate
    },
      options);
    }
  


export const getCompanyReportsActivitiesBusinessTravelFuelUsageUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelFuelUsageUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: NonReadonly<FuelUsageUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelFuelUsageUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: NonReadonly<FuelUsageUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelFuelUsageUpdate>>, {companyReportUuid: string;activityUuid: string;data: NonReadonly<FuelUsageUpdate>}> = (props) => {
          const {companyReportUuid,activityUuid,data} = props ?? {};

          return  companyReportsActivitiesBusinessTravelFuelUsageUpdate(companyReportUuid,activityUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsActivitiesBusinessTravelFuelUsageUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelFuelUsageUpdate>>>
    export type CompanyReportsActivitiesBusinessTravelFuelUsageUpdateMutationBody = NonReadonly<FuelUsageUpdate>
    export type CompanyReportsActivitiesBusinessTravelFuelUsageUpdateMutationError = unknown

    export const useCompanyReportsActivitiesBusinessTravelFuelUsageUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelFuelUsageUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: NonReadonly<FuelUsageUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelFuelUsageUpdate>>,
        TError,
        {companyReportUuid: string;activityUuid: string;data: NonReadonly<FuelUsageUpdate>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsActivitiesBusinessTravelFuelUsageUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Update a passenger-transport business travel activity.
 */
export const companyReportsActivitiesBusinessTravelPassengerTransportUpdate = (
    companyReportUuid: string,
    activityUuid: string,
    passengerTransportUpdate: NonReadonly<PassengerTransportUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ActivityUpdateResponse>(
      {url: `/company-reports/${companyReportUuid}/activities/business-travel/${activityUuid}/passenger-transport`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: passengerTransportUpdate
    },
      options);
    }
  


export const getCompanyReportsActivitiesBusinessTravelPassengerTransportUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelPassengerTransportUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: NonReadonly<PassengerTransportUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelPassengerTransportUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: NonReadonly<PassengerTransportUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelPassengerTransportUpdate>>, {companyReportUuid: string;activityUuid: string;data: NonReadonly<PassengerTransportUpdate>}> = (props) => {
          const {companyReportUuid,activityUuid,data} = props ?? {};

          return  companyReportsActivitiesBusinessTravelPassengerTransportUpdate(companyReportUuid,activityUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsActivitiesBusinessTravelPassengerTransportUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelPassengerTransportUpdate>>>
    export type CompanyReportsActivitiesBusinessTravelPassengerTransportUpdateMutationBody = NonReadonly<PassengerTransportUpdate>
    export type CompanyReportsActivitiesBusinessTravelPassengerTransportUpdateMutationError = unknown

    export const useCompanyReportsActivitiesBusinessTravelPassengerTransportUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelPassengerTransportUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: NonReadonly<PassengerTransportUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelPassengerTransportUpdate>>,
        TError,
        {companyReportUuid: string;activityUuid: string;data: NonReadonly<PassengerTransportUpdate>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsActivitiesBusinessTravelPassengerTransportUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Update a total-emissions business travel activity.
 */
export const companyReportsActivitiesBusinessTravelTotalEmissionsUpdate = (
    companyReportUuid: string,
    activityUuid: string,
    totalEmissionsUpdate: TotalEmissionsUpdate,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ActivityUpdateResponse>(
      {url: `/company-reports/${companyReportUuid}/activities/business-travel/${activityUuid}/total-emissions`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: totalEmissionsUpdate
    },
      options);
    }
  


export const getCompanyReportsActivitiesBusinessTravelTotalEmissionsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelTotalEmissionsUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: TotalEmissionsUpdate}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelTotalEmissionsUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: TotalEmissionsUpdate}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelTotalEmissionsUpdate>>, {companyReportUuid: string;activityUuid: string;data: TotalEmissionsUpdate}> = (props) => {
          const {companyReportUuid,activityUuid,data} = props ?? {};

          return  companyReportsActivitiesBusinessTravelTotalEmissionsUpdate(companyReportUuid,activityUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsActivitiesBusinessTravelTotalEmissionsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelTotalEmissionsUpdate>>>
    export type CompanyReportsActivitiesBusinessTravelTotalEmissionsUpdateMutationBody = TotalEmissionsUpdate
    export type CompanyReportsActivitiesBusinessTravelTotalEmissionsUpdateMutationError = unknown

    export const useCompanyReportsActivitiesBusinessTravelTotalEmissionsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelTotalEmissionsUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: TotalEmissionsUpdate}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelTotalEmissionsUpdate>>,
        TError,
        {companyReportUuid: string;activityUuid: string;data: TotalEmissionsUpdate},
        TContext
      > => {

      const mutationOptions = getCompanyReportsActivitiesBusinessTravelTotalEmissionsUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Create a business travel activity using the fuel-usage methodology.
 */
export const companyReportsActivitiesBusinessTravelFuelUsageCreate = (
    companyReportUuid: string,
    fuelUsageCreate: FuelUsageCreate,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<FuelUsageCreate>(
      {url: `/company-reports/${companyReportUuid}/activities/business-travel/fuel-usage`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: fuelUsageCreate
    },
      options);
    }
  


export const getCompanyReportsActivitiesBusinessTravelFuelUsageCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelFuelUsageCreate>>, TError,{companyReportUuid: string;data: FuelUsageCreate}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelFuelUsageCreate>>, TError,{companyReportUuid: string;data: FuelUsageCreate}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelFuelUsageCreate>>, {companyReportUuid: string;data: FuelUsageCreate}> = (props) => {
          const {companyReportUuid,data} = props ?? {};

          return  companyReportsActivitiesBusinessTravelFuelUsageCreate(companyReportUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsActivitiesBusinessTravelFuelUsageCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelFuelUsageCreate>>>
    export type CompanyReportsActivitiesBusinessTravelFuelUsageCreateMutationBody = FuelUsageCreate
    export type CompanyReportsActivitiesBusinessTravelFuelUsageCreateMutationError = unknown

    export const useCompanyReportsActivitiesBusinessTravelFuelUsageCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelFuelUsageCreate>>, TError,{companyReportUuid: string;data: FuelUsageCreate}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelFuelUsageCreate>>,
        TError,
        {companyReportUuid: string;data: FuelUsageCreate},
        TContext
      > => {

      const mutationOptions = getCompanyReportsActivitiesBusinessTravelFuelUsageCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Create a business travel activity using the passenger-transport methodology.
 */
export const companyReportsActivitiesBusinessTravelPassengerTransportCreate = (
    companyReportUuid: string,
    passengerTransportCreate: PassengerTransportCreate,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<PassengerTransportCreate>(
      {url: `/company-reports/${companyReportUuid}/activities/business-travel/passenger-transport`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: passengerTransportCreate
    },
      options);
    }
  


export const getCompanyReportsActivitiesBusinessTravelPassengerTransportCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelPassengerTransportCreate>>, TError,{companyReportUuid: string;data: PassengerTransportCreate}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelPassengerTransportCreate>>, TError,{companyReportUuid: string;data: PassengerTransportCreate}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelPassengerTransportCreate>>, {companyReportUuid: string;data: PassengerTransportCreate}> = (props) => {
          const {companyReportUuid,data} = props ?? {};

          return  companyReportsActivitiesBusinessTravelPassengerTransportCreate(companyReportUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsActivitiesBusinessTravelPassengerTransportCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelPassengerTransportCreate>>>
    export type CompanyReportsActivitiesBusinessTravelPassengerTransportCreateMutationBody = PassengerTransportCreate
    export type CompanyReportsActivitiesBusinessTravelPassengerTransportCreateMutationError = unknown

    export const useCompanyReportsActivitiesBusinessTravelPassengerTransportCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelPassengerTransportCreate>>, TError,{companyReportUuid: string;data: PassengerTransportCreate}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelPassengerTransportCreate>>,
        TError,
        {companyReportUuid: string;data: PassengerTransportCreate},
        TContext
      > => {

      const mutationOptions = getCompanyReportsActivitiesBusinessTravelPassengerTransportCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Create a business travel activity using the total-emissions methodology.
 */
export const companyReportsActivitiesBusinessTravelTotalEmissionsCreate = (
    companyReportUuid: string,
    totalEmissionsCreate: TotalEmissionsCreate,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<TotalEmissionsCreate>(
      {url: `/company-reports/${companyReportUuid}/activities/business-travel/total-emissions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: totalEmissionsCreate
    },
      options);
    }
  


export const getCompanyReportsActivitiesBusinessTravelTotalEmissionsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelTotalEmissionsCreate>>, TError,{companyReportUuid: string;data: TotalEmissionsCreate}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelTotalEmissionsCreate>>, TError,{companyReportUuid: string;data: TotalEmissionsCreate}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelTotalEmissionsCreate>>, {companyReportUuid: string;data: TotalEmissionsCreate}> = (props) => {
          const {companyReportUuid,data} = props ?? {};

          return  companyReportsActivitiesBusinessTravelTotalEmissionsCreate(companyReportUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsActivitiesBusinessTravelTotalEmissionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelTotalEmissionsCreate>>>
    export type CompanyReportsActivitiesBusinessTravelTotalEmissionsCreateMutationBody = TotalEmissionsCreate
    export type CompanyReportsActivitiesBusinessTravelTotalEmissionsCreateMutationError = unknown

    export const useCompanyReportsActivitiesBusinessTravelTotalEmissionsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelTotalEmissionsCreate>>, TError,{companyReportUuid: string;data: TotalEmissionsCreate}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsActivitiesBusinessTravelTotalEmissionsCreate>>,
        TError,
        {companyReportUuid: string;data: TotalEmissionsCreate},
        TContext
      > => {

      const mutationOptions = getCompanyReportsActivitiesBusinessTravelTotalEmissionsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsActivitiesDirectGasEmissionsList = (
    companyReportUuid: string,
    params?: CompanyReportsActivitiesDirectGasEmissionsListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedDirectGasEmissionActivitiesListList>(
      {url: `/company-reports/${companyReportUuid}/activities/direct-gas-emissions`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCompanyReportsActivitiesDirectGasEmissionsListQueryKey = (companyReportUuid: string,
    params?: CompanyReportsActivitiesDirectGasEmissionsListParams,) => {
    return [`/company-reports/${companyReportUuid}/activities/direct-gas-emissions`, ...(params ? [params]: [])] as const;
    }

    
export const getCompanyReportsActivitiesDirectGasEmissionsListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsList>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesDirectGasEmissionsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesDirectGasEmissionsListQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsList>>> = ({ signal, pageParam }) => companyReportsActivitiesDirectGasEmissionsList(companyReportUuid,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesDirectGasEmissionsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsList>>>
export type CompanyReportsActivitiesDirectGasEmissionsListInfiniteQueryError = unknown

export const useCompanyReportsActivitiesDirectGasEmissionsListInfinite = <TData = Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsList>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesDirectGasEmissionsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesDirectGasEmissionsListInfiniteQueryOptions(companyReportUuid,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsActivitiesDirectGasEmissionsListQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsList>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesDirectGasEmissionsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesDirectGasEmissionsListQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsList>>> = ({ signal }) => companyReportsActivitiesDirectGasEmissionsList(companyReportUuid,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesDirectGasEmissionsListQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsList>>>
export type CompanyReportsActivitiesDirectGasEmissionsListQueryError = unknown

export const useCompanyReportsActivitiesDirectGasEmissionsList = <TData = Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsList>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesDirectGasEmissionsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesDirectGasEmissionsListQueryOptions(companyReportUuid,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsActivitiesDirectGasEmissionsCreate = (
    companyReportUuid: string,
    directGasEmissionActivityCreate: NonReadonly<DirectGasEmissionActivityCreate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<DirectGasEmissionActivityCreate>(
      {url: `/company-reports/${companyReportUuid}/activities/direct-gas-emissions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: directGasEmissionActivityCreate
    },
      options);
    }
  


export const getCompanyReportsActivitiesDirectGasEmissionsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsCreate>>, TError,{companyReportUuid: string;data: NonReadonly<DirectGasEmissionActivityCreate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsCreate>>, TError,{companyReportUuid: string;data: NonReadonly<DirectGasEmissionActivityCreate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsCreate>>, {companyReportUuid: string;data: NonReadonly<DirectGasEmissionActivityCreate>}> = (props) => {
          const {companyReportUuid,data} = props ?? {};

          return  companyReportsActivitiesDirectGasEmissionsCreate(companyReportUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsActivitiesDirectGasEmissionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsCreate>>>
    export type CompanyReportsActivitiesDirectGasEmissionsCreateMutationBody = NonReadonly<DirectGasEmissionActivityCreate>
    export type CompanyReportsActivitiesDirectGasEmissionsCreateMutationError = unknown

    export const useCompanyReportsActivitiesDirectGasEmissionsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsCreate>>, TError,{companyReportUuid: string;data: NonReadonly<DirectGasEmissionActivityCreate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsCreate>>,
        TError,
        {companyReportUuid: string;data: NonReadonly<DirectGasEmissionActivityCreate>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsActivitiesDirectGasEmissionsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsActivitiesDirectGasEmissionsRetrieve = (
    companyReportUuid: string,
    activityUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<DirectGasEmissionActivityRetrieve>(
      {url: `/company-reports/${companyReportUuid}/activities/direct-gas-emissions/${activityUuid}`, method: 'GET', signal
    },
      options);
    }
  

export const getCompanyReportsActivitiesDirectGasEmissionsRetrieveQueryKey = (companyReportUuid: string,
    activityUuid: string,) => {
    return [`/company-reports/${companyReportUuid}/activities/direct-gas-emissions/${activityUuid}`] as const;
    }

    
export const getCompanyReportsActivitiesDirectGasEmissionsRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsRetrieve>>, TError = unknown>(companyReportUuid: string,
    activityUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesDirectGasEmissionsRetrieveQueryKey(companyReportUuid,activityUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsRetrieve>>> = ({ signal }) => companyReportsActivitiesDirectGasEmissionsRetrieve(companyReportUuid,activityUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid && activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesDirectGasEmissionsRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsRetrieve>>>
export type CompanyReportsActivitiesDirectGasEmissionsRetrieveInfiniteQueryError = unknown

export const useCompanyReportsActivitiesDirectGasEmissionsRetrieveInfinite = <TData = Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    activityUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesDirectGasEmissionsRetrieveInfiniteQueryOptions(companyReportUuid,activityUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsActivitiesDirectGasEmissionsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsRetrieve>>, TError = unknown>(companyReportUuid: string,
    activityUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesDirectGasEmissionsRetrieveQueryKey(companyReportUuid,activityUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsRetrieve>>> = ({ signal }) => companyReportsActivitiesDirectGasEmissionsRetrieve(companyReportUuid,activityUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid && activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesDirectGasEmissionsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsRetrieve>>>
export type CompanyReportsActivitiesDirectGasEmissionsRetrieveQueryError = unknown

export const useCompanyReportsActivitiesDirectGasEmissionsRetrieve = <TData = Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    activityUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesDirectGasEmissionsRetrieveQueryOptions(companyReportUuid,activityUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsActivitiesDirectGasEmissionsUpdate = (
    companyReportUuid: string,
    activityUuid: string,
    directGasEmissionActivityUpdate: NonReadonly<DirectGasEmissionActivityUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ActivityUpdateResponse>(
      {url: `/company-reports/${companyReportUuid}/activities/direct-gas-emissions/${activityUuid}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: directGasEmissionActivityUpdate
    },
      options);
    }
  


export const getCompanyReportsActivitiesDirectGasEmissionsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: NonReadonly<DirectGasEmissionActivityUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: NonReadonly<DirectGasEmissionActivityUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsUpdate>>, {companyReportUuid: string;activityUuid: string;data: NonReadonly<DirectGasEmissionActivityUpdate>}> = (props) => {
          const {companyReportUuid,activityUuid,data} = props ?? {};

          return  companyReportsActivitiesDirectGasEmissionsUpdate(companyReportUuid,activityUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsActivitiesDirectGasEmissionsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsUpdate>>>
    export type CompanyReportsActivitiesDirectGasEmissionsUpdateMutationBody = NonReadonly<DirectGasEmissionActivityUpdate>
    export type CompanyReportsActivitiesDirectGasEmissionsUpdateMutationError = unknown

    export const useCompanyReportsActivitiesDirectGasEmissionsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: NonReadonly<DirectGasEmissionActivityUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsUpdate>>,
        TError,
        {companyReportUuid: string;activityUuid: string;data: NonReadonly<DirectGasEmissionActivityUpdate>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsActivitiesDirectGasEmissionsUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsActivitiesDirectGasEmissionsPreviewRetrieve = (
    companyReportUuid: string,
    params?: CompanyReportsActivitiesDirectGasEmissionsPreviewRetrieveParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<DirectGasEmissionPreviewResults>(
      {url: `/company-reports/${companyReportUuid}/activities/direct-gas-emissions/preview`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCompanyReportsActivitiesDirectGasEmissionsPreviewRetrieveQueryKey = (companyReportUuid: string,
    params?: CompanyReportsActivitiesDirectGasEmissionsPreviewRetrieveParams,) => {
    return [`/company-reports/${companyReportUuid}/activities/direct-gas-emissions/preview`, ...(params ? [params]: [])] as const;
    }

    
export const getCompanyReportsActivitiesDirectGasEmissionsPreviewRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsPreviewRetrieve>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesDirectGasEmissionsPreviewRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesDirectGasEmissionsPreviewRetrieveQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsPreviewRetrieve>>> = ({ signal, pageParam }) => companyReportsActivitiesDirectGasEmissionsPreviewRetrieve(companyReportUuid,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsPreviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesDirectGasEmissionsPreviewRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsPreviewRetrieve>>>
export type CompanyReportsActivitiesDirectGasEmissionsPreviewRetrieveInfiniteQueryError = unknown

export const useCompanyReportsActivitiesDirectGasEmissionsPreviewRetrieveInfinite = <TData = Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsPreviewRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesDirectGasEmissionsPreviewRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesDirectGasEmissionsPreviewRetrieveInfiniteQueryOptions(companyReportUuid,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsActivitiesDirectGasEmissionsPreviewRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsPreviewRetrieve>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesDirectGasEmissionsPreviewRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesDirectGasEmissionsPreviewRetrieveQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsPreviewRetrieve>>> = ({ signal }) => companyReportsActivitiesDirectGasEmissionsPreviewRetrieve(companyReportUuid,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsPreviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesDirectGasEmissionsPreviewRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsPreviewRetrieve>>>
export type CompanyReportsActivitiesDirectGasEmissionsPreviewRetrieveQueryError = unknown

export const useCompanyReportsActivitiesDirectGasEmissionsPreviewRetrieve = <TData = Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsPreviewRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesDirectGasEmissionsPreviewRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesDirectGasEmissionsPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesDirectGasEmissionsPreviewRetrieveQueryOptions(companyReportUuid,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsActivitiesElectricityList = (
    companyReportUuid: string,
    params?: CompanyReportsActivitiesElectricityListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedElectricityActivitiesListList>(
      {url: `/company-reports/${companyReportUuid}/activities/electricity`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCompanyReportsActivitiesElectricityListQueryKey = (companyReportUuid: string,
    params?: CompanyReportsActivitiesElectricityListParams,) => {
    return [`/company-reports/${companyReportUuid}/activities/electricity`, ...(params ? [params]: [])] as const;
    }

    
export const getCompanyReportsActivitiesElectricityListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesElectricityList>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesElectricityListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesElectricityList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesElectricityListQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesElectricityList>>> = ({ signal, pageParam }) => companyReportsActivitiesElectricityList(companyReportUuid,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesElectricityList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesElectricityListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesElectricityList>>>
export type CompanyReportsActivitiesElectricityListInfiniteQueryError = unknown

export const useCompanyReportsActivitiesElectricityListInfinite = <TData = Awaited<ReturnType<typeof companyReportsActivitiesElectricityList>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesElectricityListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesElectricityList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesElectricityListInfiniteQueryOptions(companyReportUuid,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsActivitiesElectricityListQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesElectricityList>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesElectricityListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesElectricityList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesElectricityListQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesElectricityList>>> = ({ signal }) => companyReportsActivitiesElectricityList(companyReportUuid,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesElectricityList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesElectricityListQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesElectricityList>>>
export type CompanyReportsActivitiesElectricityListQueryError = unknown

export const useCompanyReportsActivitiesElectricityList = <TData = Awaited<ReturnType<typeof companyReportsActivitiesElectricityList>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesElectricityListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesElectricityList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesElectricityListQueryOptions(companyReportUuid,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsActivitiesElectricityCreate = (
    companyReportUuid: string,
    electricityActivityCreate: NonReadonly<ElectricityActivityCreate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ElectricityActivityCreate>(
      {url: `/company-reports/${companyReportUuid}/activities/electricity`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: electricityActivityCreate
    },
      options);
    }
  


export const getCompanyReportsActivitiesElectricityCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesElectricityCreate>>, TError,{companyReportUuid: string;data: NonReadonly<ElectricityActivityCreate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesElectricityCreate>>, TError,{companyReportUuid: string;data: NonReadonly<ElectricityActivityCreate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsActivitiesElectricityCreate>>, {companyReportUuid: string;data: NonReadonly<ElectricityActivityCreate>}> = (props) => {
          const {companyReportUuid,data} = props ?? {};

          return  companyReportsActivitiesElectricityCreate(companyReportUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsActivitiesElectricityCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesElectricityCreate>>>
    export type CompanyReportsActivitiesElectricityCreateMutationBody = NonReadonly<ElectricityActivityCreate>
    export type CompanyReportsActivitiesElectricityCreateMutationError = unknown

    export const useCompanyReportsActivitiesElectricityCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesElectricityCreate>>, TError,{companyReportUuid: string;data: NonReadonly<ElectricityActivityCreate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsActivitiesElectricityCreate>>,
        TError,
        {companyReportUuid: string;data: NonReadonly<ElectricityActivityCreate>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsActivitiesElectricityCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsActivitiesElectricityRetrieve = (
    companyReportUuid: string,
    activityUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<ElectricityActivityRetrieve>(
      {url: `/company-reports/${companyReportUuid}/activities/electricity/${activityUuid}`, method: 'GET', signal
    },
      options);
    }
  

export const getCompanyReportsActivitiesElectricityRetrieveQueryKey = (companyReportUuid: string,
    activityUuid: string,) => {
    return [`/company-reports/${companyReportUuid}/activities/electricity/${activityUuid}`] as const;
    }

    
export const getCompanyReportsActivitiesElectricityRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesElectricityRetrieve>>, TError = unknown>(companyReportUuid: string,
    activityUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesElectricityRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesElectricityRetrieveQueryKey(companyReportUuid,activityUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesElectricityRetrieve>>> = ({ signal }) => companyReportsActivitiesElectricityRetrieve(companyReportUuid,activityUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid && activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesElectricityRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesElectricityRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesElectricityRetrieve>>>
export type CompanyReportsActivitiesElectricityRetrieveInfiniteQueryError = unknown

export const useCompanyReportsActivitiesElectricityRetrieveInfinite = <TData = Awaited<ReturnType<typeof companyReportsActivitiesElectricityRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    activityUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesElectricityRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesElectricityRetrieveInfiniteQueryOptions(companyReportUuid,activityUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsActivitiesElectricityRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesElectricityRetrieve>>, TError = unknown>(companyReportUuid: string,
    activityUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesElectricityRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesElectricityRetrieveQueryKey(companyReportUuid,activityUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesElectricityRetrieve>>> = ({ signal }) => companyReportsActivitiesElectricityRetrieve(companyReportUuid,activityUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid && activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesElectricityRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesElectricityRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesElectricityRetrieve>>>
export type CompanyReportsActivitiesElectricityRetrieveQueryError = unknown

export const useCompanyReportsActivitiesElectricityRetrieve = <TData = Awaited<ReturnType<typeof companyReportsActivitiesElectricityRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    activityUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesElectricityRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesElectricityRetrieveQueryOptions(companyReportUuid,activityUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsActivitiesElectricityUpdate = (
    companyReportUuid: string,
    activityUuid: string,
    electricityActivityUpdate: NonReadonly<ElectricityActivityUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ActivityUpdateResponse>(
      {url: `/company-reports/${companyReportUuid}/activities/electricity/${activityUuid}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: electricityActivityUpdate
    },
      options);
    }
  


export const getCompanyReportsActivitiesElectricityUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesElectricityUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: NonReadonly<ElectricityActivityUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesElectricityUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: NonReadonly<ElectricityActivityUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsActivitiesElectricityUpdate>>, {companyReportUuid: string;activityUuid: string;data: NonReadonly<ElectricityActivityUpdate>}> = (props) => {
          const {companyReportUuid,activityUuid,data} = props ?? {};

          return  companyReportsActivitiesElectricityUpdate(companyReportUuid,activityUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsActivitiesElectricityUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesElectricityUpdate>>>
    export type CompanyReportsActivitiesElectricityUpdateMutationBody = NonReadonly<ElectricityActivityUpdate>
    export type CompanyReportsActivitiesElectricityUpdateMutationError = unknown

    export const useCompanyReportsActivitiesElectricityUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesElectricityUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: NonReadonly<ElectricityActivityUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsActivitiesElectricityUpdate>>,
        TError,
        {companyReportUuid: string;activityUuid: string;data: NonReadonly<ElectricityActivityUpdate>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsActivitiesElectricityUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsActivitiesElectricityPreviewRetrieve = (
    companyReportUuid: string,
    params?: CompanyReportsActivitiesElectricityPreviewRetrieveParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<ElectricityPreviewResults>(
      {url: `/company-reports/${companyReportUuid}/activities/electricity/preview`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCompanyReportsActivitiesElectricityPreviewRetrieveQueryKey = (companyReportUuid: string,
    params?: CompanyReportsActivitiesElectricityPreviewRetrieveParams,) => {
    return [`/company-reports/${companyReportUuid}/activities/electricity/preview`, ...(params ? [params]: [])] as const;
    }

    
export const getCompanyReportsActivitiesElectricityPreviewRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesElectricityPreviewRetrieve>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesElectricityPreviewRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesElectricityPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesElectricityPreviewRetrieveQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesElectricityPreviewRetrieve>>> = ({ signal, pageParam }) => companyReportsActivitiesElectricityPreviewRetrieve(companyReportUuid,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesElectricityPreviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesElectricityPreviewRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesElectricityPreviewRetrieve>>>
export type CompanyReportsActivitiesElectricityPreviewRetrieveInfiniteQueryError = unknown

export const useCompanyReportsActivitiesElectricityPreviewRetrieveInfinite = <TData = Awaited<ReturnType<typeof companyReportsActivitiesElectricityPreviewRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesElectricityPreviewRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesElectricityPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesElectricityPreviewRetrieveInfiniteQueryOptions(companyReportUuid,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsActivitiesElectricityPreviewRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesElectricityPreviewRetrieve>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesElectricityPreviewRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesElectricityPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesElectricityPreviewRetrieveQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesElectricityPreviewRetrieve>>> = ({ signal }) => companyReportsActivitiesElectricityPreviewRetrieve(companyReportUuid,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesElectricityPreviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesElectricityPreviewRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesElectricityPreviewRetrieve>>>
export type CompanyReportsActivitiesElectricityPreviewRetrieveQueryError = unknown

export const useCompanyReportsActivitiesElectricityPreviewRetrieve = <TData = Awaited<ReturnType<typeof companyReportsActivitiesElectricityPreviewRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesElectricityPreviewRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesElectricityPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesElectricityPreviewRetrieveQueryOptions(companyReportUuid,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsActivitiesFoodList = (
    companyReportUuid: string,
    params?: CompanyReportsActivitiesFoodListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedFoodActivitiesListList>(
      {url: `/company-reports/${companyReportUuid}/activities/food`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCompanyReportsActivitiesFoodListQueryKey = (companyReportUuid: string,
    params?: CompanyReportsActivitiesFoodListParams,) => {
    return [`/company-reports/${companyReportUuid}/activities/food`, ...(params ? [params]: [])] as const;
    }

    
export const getCompanyReportsActivitiesFoodListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesFoodList>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesFoodListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesFoodList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesFoodListQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesFoodList>>> = ({ signal, pageParam }) => companyReportsActivitiesFoodList(companyReportUuid,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesFoodList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesFoodListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesFoodList>>>
export type CompanyReportsActivitiesFoodListInfiniteQueryError = unknown

export const useCompanyReportsActivitiesFoodListInfinite = <TData = Awaited<ReturnType<typeof companyReportsActivitiesFoodList>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesFoodListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesFoodList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesFoodListInfiniteQueryOptions(companyReportUuid,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsActivitiesFoodListQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesFoodList>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesFoodListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesFoodList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesFoodListQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesFoodList>>> = ({ signal }) => companyReportsActivitiesFoodList(companyReportUuid,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesFoodList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesFoodListQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesFoodList>>>
export type CompanyReportsActivitiesFoodListQueryError = unknown

export const useCompanyReportsActivitiesFoodList = <TData = Awaited<ReturnType<typeof companyReportsActivitiesFoodList>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesFoodListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesFoodList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesFoodListQueryOptions(companyReportUuid,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsActivitiesFoodCreate = (
    companyReportUuid: string,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<void>(
      {url: `/company-reports/${companyReportUuid}/activities/food`, method: 'POST'
    },
      options);
    }
  


export const getCompanyReportsActivitiesFoodCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesFoodCreate>>, TError,{companyReportUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesFoodCreate>>, TError,{companyReportUuid: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsActivitiesFoodCreate>>, {companyReportUuid: string}> = (props) => {
          const {companyReportUuid} = props ?? {};

          return  companyReportsActivitiesFoodCreate(companyReportUuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsActivitiesFoodCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesFoodCreate>>>
    
    export type CompanyReportsActivitiesFoodCreateMutationError = unknown

    export const useCompanyReportsActivitiesFoodCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesFoodCreate>>, TError,{companyReportUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsActivitiesFoodCreate>>,
        TError,
        {companyReportUuid: string},
        TContext
      > => {

      const mutationOptions = getCompanyReportsActivitiesFoodCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsActivitiesFoodRetrieve = (
    companyReportUuid: string,
    activityUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<FoodActivityRetrieveUpdate>(
      {url: `/company-reports/${companyReportUuid}/activities/food/${activityUuid}`, method: 'GET', signal
    },
      options);
    }
  

export const getCompanyReportsActivitiesFoodRetrieveQueryKey = (companyReportUuid: string,
    activityUuid: string,) => {
    return [`/company-reports/${companyReportUuid}/activities/food/${activityUuid}`] as const;
    }

    
export const getCompanyReportsActivitiesFoodRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesFoodRetrieve>>, TError = unknown>(companyReportUuid: string,
    activityUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesFoodRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesFoodRetrieveQueryKey(companyReportUuid,activityUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesFoodRetrieve>>> = ({ signal }) => companyReportsActivitiesFoodRetrieve(companyReportUuid,activityUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid && activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesFoodRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesFoodRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesFoodRetrieve>>>
export type CompanyReportsActivitiesFoodRetrieveInfiniteQueryError = unknown

export const useCompanyReportsActivitiesFoodRetrieveInfinite = <TData = Awaited<ReturnType<typeof companyReportsActivitiesFoodRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    activityUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesFoodRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesFoodRetrieveInfiniteQueryOptions(companyReportUuid,activityUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsActivitiesFoodRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesFoodRetrieve>>, TError = unknown>(companyReportUuid: string,
    activityUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesFoodRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesFoodRetrieveQueryKey(companyReportUuid,activityUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesFoodRetrieve>>> = ({ signal }) => companyReportsActivitiesFoodRetrieve(companyReportUuid,activityUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid && activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesFoodRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesFoodRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesFoodRetrieve>>>
export type CompanyReportsActivitiesFoodRetrieveQueryError = unknown

export const useCompanyReportsActivitiesFoodRetrieve = <TData = Awaited<ReturnType<typeof companyReportsActivitiesFoodRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    activityUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesFoodRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesFoodRetrieveQueryOptions(companyReportUuid,activityUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsActivitiesFoodUpdate = (
    companyReportUuid: string,
    activityUuid: string,
    foodActivityRetrieveUpdate: NonReadonly<FoodActivityRetrieveUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ActivityUpdateResponse>(
      {url: `/company-reports/${companyReportUuid}/activities/food/${activityUuid}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: foodActivityRetrieveUpdate
    },
      options);
    }
  


export const getCompanyReportsActivitiesFoodUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesFoodUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: NonReadonly<FoodActivityRetrieveUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesFoodUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: NonReadonly<FoodActivityRetrieveUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsActivitiesFoodUpdate>>, {companyReportUuid: string;activityUuid: string;data: NonReadonly<FoodActivityRetrieveUpdate>}> = (props) => {
          const {companyReportUuid,activityUuid,data} = props ?? {};

          return  companyReportsActivitiesFoodUpdate(companyReportUuid,activityUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsActivitiesFoodUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesFoodUpdate>>>
    export type CompanyReportsActivitiesFoodUpdateMutationBody = NonReadonly<FoodActivityRetrieveUpdate>
    export type CompanyReportsActivitiesFoodUpdateMutationError = unknown

    export const useCompanyReportsActivitiesFoodUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesFoodUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: NonReadonly<FoodActivityRetrieveUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsActivitiesFoodUpdate>>,
        TError,
        {companyReportUuid: string;activityUuid: string;data: NonReadonly<FoodActivityRetrieveUpdate>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsActivitiesFoodUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsActivitiesFoodPreviewRetrieve = (
    companyReportUuid: string,
    params?: CompanyReportsActivitiesFoodPreviewRetrieveParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<FoodAndDrinkPreviewResults>(
      {url: `/company-reports/${companyReportUuid}/activities/food/preview`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCompanyReportsActivitiesFoodPreviewRetrieveQueryKey = (companyReportUuid: string,
    params?: CompanyReportsActivitiesFoodPreviewRetrieveParams,) => {
    return [`/company-reports/${companyReportUuid}/activities/food/preview`, ...(params ? [params]: [])] as const;
    }

    
export const getCompanyReportsActivitiesFoodPreviewRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesFoodPreviewRetrieve>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesFoodPreviewRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesFoodPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesFoodPreviewRetrieveQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesFoodPreviewRetrieve>>> = ({ signal, pageParam }) => companyReportsActivitiesFoodPreviewRetrieve(companyReportUuid,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesFoodPreviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesFoodPreviewRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesFoodPreviewRetrieve>>>
export type CompanyReportsActivitiesFoodPreviewRetrieveInfiniteQueryError = unknown

export const useCompanyReportsActivitiesFoodPreviewRetrieveInfinite = <TData = Awaited<ReturnType<typeof companyReportsActivitiesFoodPreviewRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesFoodPreviewRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesFoodPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesFoodPreviewRetrieveInfiniteQueryOptions(companyReportUuid,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsActivitiesFoodPreviewRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesFoodPreviewRetrieve>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesFoodPreviewRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesFoodPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesFoodPreviewRetrieveQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesFoodPreviewRetrieve>>> = ({ signal }) => companyReportsActivitiesFoodPreviewRetrieve(companyReportUuid,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesFoodPreviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesFoodPreviewRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesFoodPreviewRetrieve>>>
export type CompanyReportsActivitiesFoodPreviewRetrieveQueryError = unknown

export const useCompanyReportsActivitiesFoodPreviewRetrieve = <TData = Awaited<ReturnType<typeof companyReportsActivitiesFoodPreviewRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesFoodPreviewRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesFoodPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesFoodPreviewRetrieveQueryOptions(companyReportUuid,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsActivitiesHeatList = (
    companyReportUuid: string,
    params?: CompanyReportsActivitiesHeatListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedHeatActivitiesListList>(
      {url: `/company-reports/${companyReportUuid}/activities/heat`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCompanyReportsActivitiesHeatListQueryKey = (companyReportUuid: string,
    params?: CompanyReportsActivitiesHeatListParams,) => {
    return [`/company-reports/${companyReportUuid}/activities/heat`, ...(params ? [params]: [])] as const;
    }

    
export const getCompanyReportsActivitiesHeatListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesHeatList>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesHeatListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesHeatList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesHeatListQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesHeatList>>> = ({ signal, pageParam }) => companyReportsActivitiesHeatList(companyReportUuid,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesHeatList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesHeatListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesHeatList>>>
export type CompanyReportsActivitiesHeatListInfiniteQueryError = unknown

export const useCompanyReportsActivitiesHeatListInfinite = <TData = Awaited<ReturnType<typeof companyReportsActivitiesHeatList>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesHeatListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesHeatList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesHeatListInfiniteQueryOptions(companyReportUuid,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsActivitiesHeatListQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesHeatList>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesHeatListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesHeatList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesHeatListQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesHeatList>>> = ({ signal }) => companyReportsActivitiesHeatList(companyReportUuid,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesHeatList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesHeatListQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesHeatList>>>
export type CompanyReportsActivitiesHeatListQueryError = unknown

export const useCompanyReportsActivitiesHeatList = <TData = Awaited<ReturnType<typeof companyReportsActivitiesHeatList>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesHeatListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesHeatList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesHeatListQueryOptions(companyReportUuid,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsActivitiesHeatCreate = (
    companyReportUuid: string,
    heatActivityCreate: NonReadonly<HeatActivityCreate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<HeatActivityCreate>(
      {url: `/company-reports/${companyReportUuid}/activities/heat`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: heatActivityCreate
    },
      options);
    }
  


export const getCompanyReportsActivitiesHeatCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesHeatCreate>>, TError,{companyReportUuid: string;data: NonReadonly<HeatActivityCreate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesHeatCreate>>, TError,{companyReportUuid: string;data: NonReadonly<HeatActivityCreate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsActivitiesHeatCreate>>, {companyReportUuid: string;data: NonReadonly<HeatActivityCreate>}> = (props) => {
          const {companyReportUuid,data} = props ?? {};

          return  companyReportsActivitiesHeatCreate(companyReportUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsActivitiesHeatCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesHeatCreate>>>
    export type CompanyReportsActivitiesHeatCreateMutationBody = NonReadonly<HeatActivityCreate>
    export type CompanyReportsActivitiesHeatCreateMutationError = unknown

    export const useCompanyReportsActivitiesHeatCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesHeatCreate>>, TError,{companyReportUuid: string;data: NonReadonly<HeatActivityCreate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsActivitiesHeatCreate>>,
        TError,
        {companyReportUuid: string;data: NonReadonly<HeatActivityCreate>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsActivitiesHeatCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsActivitiesHeatRetrieve = (
    companyReportUuid: string,
    activityUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<HeatActivityRetrieve>(
      {url: `/company-reports/${companyReportUuid}/activities/heat/${activityUuid}`, method: 'GET', signal
    },
      options);
    }
  

export const getCompanyReportsActivitiesHeatRetrieveQueryKey = (companyReportUuid: string,
    activityUuid: string,) => {
    return [`/company-reports/${companyReportUuid}/activities/heat/${activityUuid}`] as const;
    }

    
export const getCompanyReportsActivitiesHeatRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesHeatRetrieve>>, TError = unknown>(companyReportUuid: string,
    activityUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesHeatRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesHeatRetrieveQueryKey(companyReportUuid,activityUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesHeatRetrieve>>> = ({ signal }) => companyReportsActivitiesHeatRetrieve(companyReportUuid,activityUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid && activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesHeatRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesHeatRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesHeatRetrieve>>>
export type CompanyReportsActivitiesHeatRetrieveInfiniteQueryError = unknown

export const useCompanyReportsActivitiesHeatRetrieveInfinite = <TData = Awaited<ReturnType<typeof companyReportsActivitiesHeatRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    activityUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesHeatRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesHeatRetrieveInfiniteQueryOptions(companyReportUuid,activityUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsActivitiesHeatRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesHeatRetrieve>>, TError = unknown>(companyReportUuid: string,
    activityUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesHeatRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesHeatRetrieveQueryKey(companyReportUuid,activityUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesHeatRetrieve>>> = ({ signal }) => companyReportsActivitiesHeatRetrieve(companyReportUuid,activityUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid && activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesHeatRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesHeatRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesHeatRetrieve>>>
export type CompanyReportsActivitiesHeatRetrieveQueryError = unknown

export const useCompanyReportsActivitiesHeatRetrieve = <TData = Awaited<ReturnType<typeof companyReportsActivitiesHeatRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    activityUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesHeatRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesHeatRetrieveQueryOptions(companyReportUuid,activityUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsActivitiesHeatUpdate = (
    companyReportUuid: string,
    activityUuid: string,
    heatActivityUpdate: NonReadonly<HeatActivityUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ActivityUpdateResponse>(
      {url: `/company-reports/${companyReportUuid}/activities/heat/${activityUuid}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: heatActivityUpdate
    },
      options);
    }
  


export const getCompanyReportsActivitiesHeatUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesHeatUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: NonReadonly<HeatActivityUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesHeatUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: NonReadonly<HeatActivityUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsActivitiesHeatUpdate>>, {companyReportUuid: string;activityUuid: string;data: NonReadonly<HeatActivityUpdate>}> = (props) => {
          const {companyReportUuid,activityUuid,data} = props ?? {};

          return  companyReportsActivitiesHeatUpdate(companyReportUuid,activityUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsActivitiesHeatUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesHeatUpdate>>>
    export type CompanyReportsActivitiesHeatUpdateMutationBody = NonReadonly<HeatActivityUpdate>
    export type CompanyReportsActivitiesHeatUpdateMutationError = unknown

    export const useCompanyReportsActivitiesHeatUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesHeatUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: NonReadonly<HeatActivityUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsActivitiesHeatUpdate>>,
        TError,
        {companyReportUuid: string;activityUuid: string;data: NonReadonly<HeatActivityUpdate>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsActivitiesHeatUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsActivitiesHeatPreviewRetrieve = (
    companyReportUuid: string,
    params?: CompanyReportsActivitiesHeatPreviewRetrieveParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<HeatActivityPreviewResults>(
      {url: `/company-reports/${companyReportUuid}/activities/heat/preview`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCompanyReportsActivitiesHeatPreviewRetrieveQueryKey = (companyReportUuid: string,
    params?: CompanyReportsActivitiesHeatPreviewRetrieveParams,) => {
    return [`/company-reports/${companyReportUuid}/activities/heat/preview`, ...(params ? [params]: [])] as const;
    }

    
export const getCompanyReportsActivitiesHeatPreviewRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesHeatPreviewRetrieve>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesHeatPreviewRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesHeatPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesHeatPreviewRetrieveQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesHeatPreviewRetrieve>>> = ({ signal, pageParam }) => companyReportsActivitiesHeatPreviewRetrieve(companyReportUuid,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesHeatPreviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesHeatPreviewRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesHeatPreviewRetrieve>>>
export type CompanyReportsActivitiesHeatPreviewRetrieveInfiniteQueryError = unknown

export const useCompanyReportsActivitiesHeatPreviewRetrieveInfinite = <TData = Awaited<ReturnType<typeof companyReportsActivitiesHeatPreviewRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesHeatPreviewRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesHeatPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesHeatPreviewRetrieveInfiniteQueryOptions(companyReportUuid,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsActivitiesHeatPreviewRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesHeatPreviewRetrieve>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesHeatPreviewRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesHeatPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesHeatPreviewRetrieveQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesHeatPreviewRetrieve>>> = ({ signal }) => companyReportsActivitiesHeatPreviewRetrieve(companyReportUuid,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesHeatPreviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesHeatPreviewRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesHeatPreviewRetrieve>>>
export type CompanyReportsActivitiesHeatPreviewRetrieveQueryError = unknown

export const useCompanyReportsActivitiesHeatPreviewRetrieve = <TData = Awaited<ReturnType<typeof companyReportsActivitiesHeatPreviewRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesHeatPreviewRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesHeatPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesHeatPreviewRetrieveQueryOptions(companyReportUuid,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsActivitiesMobileCombustionList = (
    companyReportUuid: string,
    params?: CompanyReportsActivitiesMobileCombustionListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedMobileCombustionActivitiesListList>(
      {url: `/company-reports/${companyReportUuid}/activities/mobile-combustion`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCompanyReportsActivitiesMobileCombustionListQueryKey = (companyReportUuid: string,
    params?: CompanyReportsActivitiesMobileCombustionListParams,) => {
    return [`/company-reports/${companyReportUuid}/activities/mobile-combustion`, ...(params ? [params]: [])] as const;
    }

    
export const getCompanyReportsActivitiesMobileCombustionListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionList>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesMobileCombustionListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesMobileCombustionListQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionList>>> = ({ signal, pageParam }) => companyReportsActivitiesMobileCombustionList(companyReportUuid,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesMobileCombustionListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionList>>>
export type CompanyReportsActivitiesMobileCombustionListInfiniteQueryError = unknown

export const useCompanyReportsActivitiesMobileCombustionListInfinite = <TData = Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionList>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesMobileCombustionListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesMobileCombustionListInfiniteQueryOptions(companyReportUuid,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsActivitiesMobileCombustionListQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionList>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesMobileCombustionListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesMobileCombustionListQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionList>>> = ({ signal }) => companyReportsActivitiesMobileCombustionList(companyReportUuid,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesMobileCombustionListQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionList>>>
export type CompanyReportsActivitiesMobileCombustionListQueryError = unknown

export const useCompanyReportsActivitiesMobileCombustionList = <TData = Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionList>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesMobileCombustionListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesMobileCombustionListQueryOptions(companyReportUuid,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsActivitiesMobileCombustionCreate = (
    companyReportUuid: string,
    mobileCombustionActivityCreate: NonReadonly<MobileCombustionActivityCreate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<MobileCombustionActivityCreate>(
      {url: `/company-reports/${companyReportUuid}/activities/mobile-combustion`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: mobileCombustionActivityCreate
    },
      options);
    }
  


export const getCompanyReportsActivitiesMobileCombustionCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionCreate>>, TError,{companyReportUuid: string;data: NonReadonly<MobileCombustionActivityCreate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionCreate>>, TError,{companyReportUuid: string;data: NonReadonly<MobileCombustionActivityCreate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionCreate>>, {companyReportUuid: string;data: NonReadonly<MobileCombustionActivityCreate>}> = (props) => {
          const {companyReportUuid,data} = props ?? {};

          return  companyReportsActivitiesMobileCombustionCreate(companyReportUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsActivitiesMobileCombustionCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionCreate>>>
    export type CompanyReportsActivitiesMobileCombustionCreateMutationBody = NonReadonly<MobileCombustionActivityCreate>
    export type CompanyReportsActivitiesMobileCombustionCreateMutationError = unknown

    export const useCompanyReportsActivitiesMobileCombustionCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionCreate>>, TError,{companyReportUuid: string;data: NonReadonly<MobileCombustionActivityCreate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionCreate>>,
        TError,
        {companyReportUuid: string;data: NonReadonly<MobileCombustionActivityCreate>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsActivitiesMobileCombustionCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsActivitiesMobileCombustionRetrieve = (
    companyReportUuid: string,
    activityUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<MobileCombustionActivityRetrieve>(
      {url: `/company-reports/${companyReportUuid}/activities/mobile-combustion/${activityUuid}`, method: 'GET', signal
    },
      options);
    }
  

export const getCompanyReportsActivitiesMobileCombustionRetrieveQueryKey = (companyReportUuid: string,
    activityUuid: string,) => {
    return [`/company-reports/${companyReportUuid}/activities/mobile-combustion/${activityUuid}`] as const;
    }

    
export const getCompanyReportsActivitiesMobileCombustionRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionRetrieve>>, TError = unknown>(companyReportUuid: string,
    activityUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesMobileCombustionRetrieveQueryKey(companyReportUuid,activityUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionRetrieve>>> = ({ signal }) => companyReportsActivitiesMobileCombustionRetrieve(companyReportUuid,activityUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid && activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesMobileCombustionRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionRetrieve>>>
export type CompanyReportsActivitiesMobileCombustionRetrieveInfiniteQueryError = unknown

export const useCompanyReportsActivitiesMobileCombustionRetrieveInfinite = <TData = Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    activityUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesMobileCombustionRetrieveInfiniteQueryOptions(companyReportUuid,activityUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsActivitiesMobileCombustionRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionRetrieve>>, TError = unknown>(companyReportUuid: string,
    activityUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesMobileCombustionRetrieveQueryKey(companyReportUuid,activityUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionRetrieve>>> = ({ signal }) => companyReportsActivitiesMobileCombustionRetrieve(companyReportUuid,activityUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid && activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesMobileCombustionRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionRetrieve>>>
export type CompanyReportsActivitiesMobileCombustionRetrieveQueryError = unknown

export const useCompanyReportsActivitiesMobileCombustionRetrieve = <TData = Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    activityUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesMobileCombustionRetrieveQueryOptions(companyReportUuid,activityUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsActivitiesMobileCombustionUpdate = (
    companyReportUuid: string,
    activityUuid: string,
    mobileCombustionActivityUpdate: NonReadonly<MobileCombustionActivityUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ActivityUpdateResponse>(
      {url: `/company-reports/${companyReportUuid}/activities/mobile-combustion/${activityUuid}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: mobileCombustionActivityUpdate
    },
      options);
    }
  


export const getCompanyReportsActivitiesMobileCombustionUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: NonReadonly<MobileCombustionActivityUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: NonReadonly<MobileCombustionActivityUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionUpdate>>, {companyReportUuid: string;activityUuid: string;data: NonReadonly<MobileCombustionActivityUpdate>}> = (props) => {
          const {companyReportUuid,activityUuid,data} = props ?? {};

          return  companyReportsActivitiesMobileCombustionUpdate(companyReportUuid,activityUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsActivitiesMobileCombustionUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionUpdate>>>
    export type CompanyReportsActivitiesMobileCombustionUpdateMutationBody = NonReadonly<MobileCombustionActivityUpdate>
    export type CompanyReportsActivitiesMobileCombustionUpdateMutationError = unknown

    export const useCompanyReportsActivitiesMobileCombustionUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: NonReadonly<MobileCombustionActivityUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionUpdate>>,
        TError,
        {companyReportUuid: string;activityUuid: string;data: NonReadonly<MobileCombustionActivityUpdate>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsActivitiesMobileCombustionUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsActivitiesMobileCombustionPreviewRetrieve = (
    companyReportUuid: string,
    params?: CompanyReportsActivitiesMobileCombustionPreviewRetrieveParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<MobileCombustionPreviewResults>(
      {url: `/company-reports/${companyReportUuid}/activities/mobile-combustion/preview`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCompanyReportsActivitiesMobileCombustionPreviewRetrieveQueryKey = (companyReportUuid: string,
    params?: CompanyReportsActivitiesMobileCombustionPreviewRetrieveParams,) => {
    return [`/company-reports/${companyReportUuid}/activities/mobile-combustion/preview`, ...(params ? [params]: [])] as const;
    }

    
export const getCompanyReportsActivitiesMobileCombustionPreviewRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionPreviewRetrieve>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesMobileCombustionPreviewRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesMobileCombustionPreviewRetrieveQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionPreviewRetrieve>>> = ({ signal, pageParam }) => companyReportsActivitiesMobileCombustionPreviewRetrieve(companyReportUuid,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionPreviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesMobileCombustionPreviewRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionPreviewRetrieve>>>
export type CompanyReportsActivitiesMobileCombustionPreviewRetrieveInfiniteQueryError = unknown

export const useCompanyReportsActivitiesMobileCombustionPreviewRetrieveInfinite = <TData = Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionPreviewRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesMobileCombustionPreviewRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesMobileCombustionPreviewRetrieveInfiniteQueryOptions(companyReportUuid,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsActivitiesMobileCombustionPreviewRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionPreviewRetrieve>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesMobileCombustionPreviewRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesMobileCombustionPreviewRetrieveQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionPreviewRetrieve>>> = ({ signal }) => companyReportsActivitiesMobileCombustionPreviewRetrieve(companyReportUuid,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionPreviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesMobileCombustionPreviewRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionPreviewRetrieve>>>
export type CompanyReportsActivitiesMobileCombustionPreviewRetrieveQueryError = unknown

export const useCompanyReportsActivitiesMobileCombustionPreviewRetrieve = <TData = Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionPreviewRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesMobileCombustionPreviewRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesMobileCombustionPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesMobileCombustionPreviewRetrieveQueryOptions(companyReportUuid,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsActivitiesPackagingList = (
    companyReportUuid: string,
    params?: CompanyReportsActivitiesPackagingListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedPackagingActivitiesListList>(
      {url: `/company-reports/${companyReportUuid}/activities/packaging`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCompanyReportsActivitiesPackagingListQueryKey = (companyReportUuid: string,
    params?: CompanyReportsActivitiesPackagingListParams,) => {
    return [`/company-reports/${companyReportUuid}/activities/packaging`, ...(params ? [params]: [])] as const;
    }

    
export const getCompanyReportsActivitiesPackagingListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesPackagingList>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesPackagingListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesPackagingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesPackagingListQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesPackagingList>>> = ({ signal, pageParam }) => companyReportsActivitiesPackagingList(companyReportUuid,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesPackagingList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesPackagingListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesPackagingList>>>
export type CompanyReportsActivitiesPackagingListInfiniteQueryError = unknown

export const useCompanyReportsActivitiesPackagingListInfinite = <TData = Awaited<ReturnType<typeof companyReportsActivitiesPackagingList>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesPackagingListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesPackagingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesPackagingListInfiniteQueryOptions(companyReportUuid,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsActivitiesPackagingListQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesPackagingList>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesPackagingListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesPackagingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesPackagingListQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesPackagingList>>> = ({ signal }) => companyReportsActivitiesPackagingList(companyReportUuid,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesPackagingList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesPackagingListQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesPackagingList>>>
export type CompanyReportsActivitiesPackagingListQueryError = unknown

export const useCompanyReportsActivitiesPackagingList = <TData = Awaited<ReturnType<typeof companyReportsActivitiesPackagingList>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesPackagingListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesPackagingList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesPackagingListQueryOptions(companyReportUuid,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsActivitiesPackagingCreate = (
    companyReportUuid: string,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<void>(
      {url: `/company-reports/${companyReportUuid}/activities/packaging`, method: 'POST'
    },
      options);
    }
  


export const getCompanyReportsActivitiesPackagingCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesPackagingCreate>>, TError,{companyReportUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesPackagingCreate>>, TError,{companyReportUuid: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsActivitiesPackagingCreate>>, {companyReportUuid: string}> = (props) => {
          const {companyReportUuid} = props ?? {};

          return  companyReportsActivitiesPackagingCreate(companyReportUuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsActivitiesPackagingCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesPackagingCreate>>>
    
    export type CompanyReportsActivitiesPackagingCreateMutationError = unknown

    export const useCompanyReportsActivitiesPackagingCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesPackagingCreate>>, TError,{companyReportUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsActivitiesPackagingCreate>>,
        TError,
        {companyReportUuid: string},
        TContext
      > => {

      const mutationOptions = getCompanyReportsActivitiesPackagingCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsActivitiesPackagingRetrieve = (
    companyReportUuid: string,
    activityUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PackagingActivityRetrieve>(
      {url: `/company-reports/${companyReportUuid}/activities/packaging/${activityUuid}`, method: 'GET', signal
    },
      options);
    }
  

export const getCompanyReportsActivitiesPackagingRetrieveQueryKey = (companyReportUuid: string,
    activityUuid: string,) => {
    return [`/company-reports/${companyReportUuid}/activities/packaging/${activityUuid}`] as const;
    }

    
export const getCompanyReportsActivitiesPackagingRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesPackagingRetrieve>>, TError = unknown>(companyReportUuid: string,
    activityUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesPackagingRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesPackagingRetrieveQueryKey(companyReportUuid,activityUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesPackagingRetrieve>>> = ({ signal }) => companyReportsActivitiesPackagingRetrieve(companyReportUuid,activityUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid && activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesPackagingRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesPackagingRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesPackagingRetrieve>>>
export type CompanyReportsActivitiesPackagingRetrieveInfiniteQueryError = unknown

export const useCompanyReportsActivitiesPackagingRetrieveInfinite = <TData = Awaited<ReturnType<typeof companyReportsActivitiesPackagingRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    activityUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesPackagingRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesPackagingRetrieveInfiniteQueryOptions(companyReportUuid,activityUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsActivitiesPackagingRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesPackagingRetrieve>>, TError = unknown>(companyReportUuid: string,
    activityUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesPackagingRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesPackagingRetrieveQueryKey(companyReportUuid,activityUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesPackagingRetrieve>>> = ({ signal }) => companyReportsActivitiesPackagingRetrieve(companyReportUuid,activityUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid && activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesPackagingRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesPackagingRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesPackagingRetrieve>>>
export type CompanyReportsActivitiesPackagingRetrieveQueryError = unknown

export const useCompanyReportsActivitiesPackagingRetrieve = <TData = Awaited<ReturnType<typeof companyReportsActivitiesPackagingRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    activityUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesPackagingRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesPackagingRetrieveQueryOptions(companyReportUuid,activityUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsActivitiesPackagingUpdate = (
    companyReportUuid: string,
    activityUuid: string,
    packagingActivityUpdate: NonReadonly<PackagingActivityUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ActivityUpdateResponse>(
      {url: `/company-reports/${companyReportUuid}/activities/packaging/${activityUuid}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: packagingActivityUpdate
    },
      options);
    }
  


export const getCompanyReportsActivitiesPackagingUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesPackagingUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: NonReadonly<PackagingActivityUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesPackagingUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: NonReadonly<PackagingActivityUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsActivitiesPackagingUpdate>>, {companyReportUuid: string;activityUuid: string;data: NonReadonly<PackagingActivityUpdate>}> = (props) => {
          const {companyReportUuid,activityUuid,data} = props ?? {};

          return  companyReportsActivitiesPackagingUpdate(companyReportUuid,activityUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsActivitiesPackagingUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesPackagingUpdate>>>
    export type CompanyReportsActivitiesPackagingUpdateMutationBody = NonReadonly<PackagingActivityUpdate>
    export type CompanyReportsActivitiesPackagingUpdateMutationError = unknown

    export const useCompanyReportsActivitiesPackagingUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesPackagingUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: NonReadonly<PackagingActivityUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsActivitiesPackagingUpdate>>,
        TError,
        {companyReportUuid: string;activityUuid: string;data: NonReadonly<PackagingActivityUpdate>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsActivitiesPackagingUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsActivitiesPackagingPreviewRetrieve = (
    companyReportUuid: string,
    params?: CompanyReportsActivitiesPackagingPreviewRetrieveParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PackagingPreviewResults>(
      {url: `/company-reports/${companyReportUuid}/activities/packaging/preview`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCompanyReportsActivitiesPackagingPreviewRetrieveQueryKey = (companyReportUuid: string,
    params?: CompanyReportsActivitiesPackagingPreviewRetrieveParams,) => {
    return [`/company-reports/${companyReportUuid}/activities/packaging/preview`, ...(params ? [params]: [])] as const;
    }

    
export const getCompanyReportsActivitiesPackagingPreviewRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesPackagingPreviewRetrieve>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesPackagingPreviewRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesPackagingPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesPackagingPreviewRetrieveQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesPackagingPreviewRetrieve>>> = ({ signal, pageParam }) => companyReportsActivitiesPackagingPreviewRetrieve(companyReportUuid,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesPackagingPreviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesPackagingPreviewRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesPackagingPreviewRetrieve>>>
export type CompanyReportsActivitiesPackagingPreviewRetrieveInfiniteQueryError = unknown

export const useCompanyReportsActivitiesPackagingPreviewRetrieveInfinite = <TData = Awaited<ReturnType<typeof companyReportsActivitiesPackagingPreviewRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesPackagingPreviewRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesPackagingPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesPackagingPreviewRetrieveInfiniteQueryOptions(companyReportUuid,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsActivitiesPackagingPreviewRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesPackagingPreviewRetrieve>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesPackagingPreviewRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesPackagingPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesPackagingPreviewRetrieveQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesPackagingPreviewRetrieve>>> = ({ signal }) => companyReportsActivitiesPackagingPreviewRetrieve(companyReportUuid,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesPackagingPreviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesPackagingPreviewRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesPackagingPreviewRetrieve>>>
export type CompanyReportsActivitiesPackagingPreviewRetrieveQueryError = unknown

export const useCompanyReportsActivitiesPackagingPreviewRetrieve = <TData = Awaited<ReturnType<typeof companyReportsActivitiesPackagingPreviewRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesPackagingPreviewRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesPackagingPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesPackagingPreviewRetrieveQueryOptions(companyReportUuid,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsActivitiesStationaryCombustionList = (
    companyReportUuid: string,
    params?: CompanyReportsActivitiesStationaryCombustionListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedStationaryCombustionActivitiesListList>(
      {url: `/company-reports/${companyReportUuid}/activities/stationary-combustion`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCompanyReportsActivitiesStationaryCombustionListQueryKey = (companyReportUuid: string,
    params?: CompanyReportsActivitiesStationaryCombustionListParams,) => {
    return [`/company-reports/${companyReportUuid}/activities/stationary-combustion`, ...(params ? [params]: [])] as const;
    }

    
export const getCompanyReportsActivitiesStationaryCombustionListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionList>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesStationaryCombustionListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesStationaryCombustionListQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionList>>> = ({ signal, pageParam }) => companyReportsActivitiesStationaryCombustionList(companyReportUuid,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesStationaryCombustionListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionList>>>
export type CompanyReportsActivitiesStationaryCombustionListInfiniteQueryError = unknown

export const useCompanyReportsActivitiesStationaryCombustionListInfinite = <TData = Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionList>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesStationaryCombustionListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesStationaryCombustionListInfiniteQueryOptions(companyReportUuid,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsActivitiesStationaryCombustionListQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionList>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesStationaryCombustionListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesStationaryCombustionListQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionList>>> = ({ signal }) => companyReportsActivitiesStationaryCombustionList(companyReportUuid,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesStationaryCombustionListQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionList>>>
export type CompanyReportsActivitiesStationaryCombustionListQueryError = unknown

export const useCompanyReportsActivitiesStationaryCombustionList = <TData = Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionList>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesStationaryCombustionListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesStationaryCombustionListQueryOptions(companyReportUuid,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsActivitiesStationaryCombustionCreate = (
    companyReportUuid: string,
    stationaryCombustionActivityCreate: NonReadonly<StationaryCombustionActivityCreate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<StationaryCombustionActivityCreate>(
      {url: `/company-reports/${companyReportUuid}/activities/stationary-combustion`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: stationaryCombustionActivityCreate
    },
      options);
    }
  


export const getCompanyReportsActivitiesStationaryCombustionCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionCreate>>, TError,{companyReportUuid: string;data: NonReadonly<StationaryCombustionActivityCreate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionCreate>>, TError,{companyReportUuid: string;data: NonReadonly<StationaryCombustionActivityCreate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionCreate>>, {companyReportUuid: string;data: NonReadonly<StationaryCombustionActivityCreate>}> = (props) => {
          const {companyReportUuid,data} = props ?? {};

          return  companyReportsActivitiesStationaryCombustionCreate(companyReportUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsActivitiesStationaryCombustionCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionCreate>>>
    export type CompanyReportsActivitiesStationaryCombustionCreateMutationBody = NonReadonly<StationaryCombustionActivityCreate>
    export type CompanyReportsActivitiesStationaryCombustionCreateMutationError = unknown

    export const useCompanyReportsActivitiesStationaryCombustionCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionCreate>>, TError,{companyReportUuid: string;data: NonReadonly<StationaryCombustionActivityCreate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionCreate>>,
        TError,
        {companyReportUuid: string;data: NonReadonly<StationaryCombustionActivityCreate>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsActivitiesStationaryCombustionCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsActivitiesStationaryCombustionRetrieve = (
    companyReportUuid: string,
    activityUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<StationaryCombustionActivityRetrieve>(
      {url: `/company-reports/${companyReportUuid}/activities/stationary-combustion/${activityUuid}`, method: 'GET', signal
    },
      options);
    }
  

export const getCompanyReportsActivitiesStationaryCombustionRetrieveQueryKey = (companyReportUuid: string,
    activityUuid: string,) => {
    return [`/company-reports/${companyReportUuid}/activities/stationary-combustion/${activityUuid}`] as const;
    }

    
export const getCompanyReportsActivitiesStationaryCombustionRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionRetrieve>>, TError = unknown>(companyReportUuid: string,
    activityUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesStationaryCombustionRetrieveQueryKey(companyReportUuid,activityUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionRetrieve>>> = ({ signal }) => companyReportsActivitiesStationaryCombustionRetrieve(companyReportUuid,activityUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid && activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesStationaryCombustionRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionRetrieve>>>
export type CompanyReportsActivitiesStationaryCombustionRetrieveInfiniteQueryError = unknown

export const useCompanyReportsActivitiesStationaryCombustionRetrieveInfinite = <TData = Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    activityUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesStationaryCombustionRetrieveInfiniteQueryOptions(companyReportUuid,activityUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsActivitiesStationaryCombustionRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionRetrieve>>, TError = unknown>(companyReportUuid: string,
    activityUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesStationaryCombustionRetrieveQueryKey(companyReportUuid,activityUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionRetrieve>>> = ({ signal }) => companyReportsActivitiesStationaryCombustionRetrieve(companyReportUuid,activityUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid && activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesStationaryCombustionRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionRetrieve>>>
export type CompanyReportsActivitiesStationaryCombustionRetrieveQueryError = unknown

export const useCompanyReportsActivitiesStationaryCombustionRetrieve = <TData = Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    activityUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesStationaryCombustionRetrieveQueryOptions(companyReportUuid,activityUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsActivitiesStationaryCombustionUpdate = (
    companyReportUuid: string,
    activityUuid: string,
    stationaryCombustionActivityUpdate: NonReadonly<StationaryCombustionActivityUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ActivityUpdateResponse>(
      {url: `/company-reports/${companyReportUuid}/activities/stationary-combustion/${activityUuid}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: stationaryCombustionActivityUpdate
    },
      options);
    }
  


export const getCompanyReportsActivitiesStationaryCombustionUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: NonReadonly<StationaryCombustionActivityUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: NonReadonly<StationaryCombustionActivityUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionUpdate>>, {companyReportUuid: string;activityUuid: string;data: NonReadonly<StationaryCombustionActivityUpdate>}> = (props) => {
          const {companyReportUuid,activityUuid,data} = props ?? {};

          return  companyReportsActivitiesStationaryCombustionUpdate(companyReportUuid,activityUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsActivitiesStationaryCombustionUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionUpdate>>>
    export type CompanyReportsActivitiesStationaryCombustionUpdateMutationBody = NonReadonly<StationaryCombustionActivityUpdate>
    export type CompanyReportsActivitiesStationaryCombustionUpdateMutationError = unknown

    export const useCompanyReportsActivitiesStationaryCombustionUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionUpdate>>, TError,{companyReportUuid: string;activityUuid: string;data: NonReadonly<StationaryCombustionActivityUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionUpdate>>,
        TError,
        {companyReportUuid: string;activityUuid: string;data: NonReadonly<StationaryCombustionActivityUpdate>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsActivitiesStationaryCombustionUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsActivitiesStationaryCombustionPreviewRetrieve = (
    companyReportUuid: string,
    params?: CompanyReportsActivitiesStationaryCombustionPreviewRetrieveParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<StationaryCombustionPreviewResults>(
      {url: `/company-reports/${companyReportUuid}/activities/stationary-combustion/preview`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCompanyReportsActivitiesStationaryCombustionPreviewRetrieveQueryKey = (companyReportUuid: string,
    params?: CompanyReportsActivitiesStationaryCombustionPreviewRetrieveParams,) => {
    return [`/company-reports/${companyReportUuid}/activities/stationary-combustion/preview`, ...(params ? [params]: [])] as const;
    }

    
export const getCompanyReportsActivitiesStationaryCombustionPreviewRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionPreviewRetrieve>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesStationaryCombustionPreviewRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesStationaryCombustionPreviewRetrieveQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionPreviewRetrieve>>> = ({ signal, pageParam }) => companyReportsActivitiesStationaryCombustionPreviewRetrieve(companyReportUuid,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionPreviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesStationaryCombustionPreviewRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionPreviewRetrieve>>>
export type CompanyReportsActivitiesStationaryCombustionPreviewRetrieveInfiniteQueryError = unknown

export const useCompanyReportsActivitiesStationaryCombustionPreviewRetrieveInfinite = <TData = Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionPreviewRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesStationaryCombustionPreviewRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesStationaryCombustionPreviewRetrieveInfiniteQueryOptions(companyReportUuid,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsActivitiesStationaryCombustionPreviewRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionPreviewRetrieve>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesStationaryCombustionPreviewRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesStationaryCombustionPreviewRetrieveQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionPreviewRetrieve>>> = ({ signal }) => companyReportsActivitiesStationaryCombustionPreviewRetrieve(companyReportUuid,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionPreviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesStationaryCombustionPreviewRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionPreviewRetrieve>>>
export type CompanyReportsActivitiesStationaryCombustionPreviewRetrieveQueryError = unknown

export const useCompanyReportsActivitiesStationaryCombustionPreviewRetrieve = <TData = Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionPreviewRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesStationaryCombustionPreviewRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesStationaryCombustionPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesStationaryCombustionPreviewRetrieveQueryOptions(companyReportUuid,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsActivitiesSupplyChainLogisticsList = (
    companyReportUuid: string,
    params?: CompanyReportsActivitiesSupplyChainLogisticsListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedSupplyChainLogisticsActivitiesListList>(
      {url: `/company-reports/${companyReportUuid}/activities/supply-chain-logistics`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCompanyReportsActivitiesSupplyChainLogisticsListQueryKey = (companyReportUuid: string,
    params?: CompanyReportsActivitiesSupplyChainLogisticsListParams,) => {
    return [`/company-reports/${companyReportUuid}/activities/supply-chain-logistics`, ...(params ? [params]: [])] as const;
    }

    
export const getCompanyReportsActivitiesSupplyChainLogisticsListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsList>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesSupplyChainLogisticsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesSupplyChainLogisticsListQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsList>>> = ({ signal, pageParam }) => companyReportsActivitiesSupplyChainLogisticsList(companyReportUuid,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesSupplyChainLogisticsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsList>>>
export type CompanyReportsActivitiesSupplyChainLogisticsListInfiniteQueryError = unknown

export const useCompanyReportsActivitiesSupplyChainLogisticsListInfinite = <TData = Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsList>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesSupplyChainLogisticsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesSupplyChainLogisticsListInfiniteQueryOptions(companyReportUuid,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsActivitiesSupplyChainLogisticsListQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsList>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesSupplyChainLogisticsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesSupplyChainLogisticsListQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsList>>> = ({ signal }) => companyReportsActivitiesSupplyChainLogisticsList(companyReportUuid,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesSupplyChainLogisticsListQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsList>>>
export type CompanyReportsActivitiesSupplyChainLogisticsListQueryError = unknown

export const useCompanyReportsActivitiesSupplyChainLogisticsList = <TData = Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsList>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesSupplyChainLogisticsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesSupplyChainLogisticsListQueryOptions(companyReportUuid,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsActivitiesSupplyChainLogisticsCreate = (
    companyReportUuid: string,
    supplyChainLogisticsActivityCreate: NonReadonly<SupplyChainLogisticsActivityCreate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<SupplyChainLogisticsActivityCreate>(
      {url: `/company-reports/${companyReportUuid}/activities/supply-chain-logistics`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: supplyChainLogisticsActivityCreate
    },
      options);
    }
  


export const getCompanyReportsActivitiesSupplyChainLogisticsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsCreate>>, TError,{companyReportUuid: string;data: NonReadonly<SupplyChainLogisticsActivityCreate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsCreate>>, TError,{companyReportUuid: string;data: NonReadonly<SupplyChainLogisticsActivityCreate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsCreate>>, {companyReportUuid: string;data: NonReadonly<SupplyChainLogisticsActivityCreate>}> = (props) => {
          const {companyReportUuid,data} = props ?? {};

          return  companyReportsActivitiesSupplyChainLogisticsCreate(companyReportUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsActivitiesSupplyChainLogisticsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsCreate>>>
    export type CompanyReportsActivitiesSupplyChainLogisticsCreateMutationBody = NonReadonly<SupplyChainLogisticsActivityCreate>
    export type CompanyReportsActivitiesSupplyChainLogisticsCreateMutationError = unknown

    export const useCompanyReportsActivitiesSupplyChainLogisticsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsCreate>>, TError,{companyReportUuid: string;data: NonReadonly<SupplyChainLogisticsActivityCreate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsCreate>>,
        TError,
        {companyReportUuid: string;data: NonReadonly<SupplyChainLogisticsActivityCreate>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsActivitiesSupplyChainLogisticsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsActivitiesSupplyChainLogisticsRetrieve = (
    companyReportUuid: string,
    activityUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<void>(
      {url: `/company-reports/${companyReportUuid}/activities/supply-chain-logistics/${activityUuid}`, method: 'GET', signal
    },
      options);
    }
  

export const getCompanyReportsActivitiesSupplyChainLogisticsRetrieveQueryKey = (companyReportUuid: string,
    activityUuid: string,) => {
    return [`/company-reports/${companyReportUuid}/activities/supply-chain-logistics/${activityUuid}`] as const;
    }

    
export const getCompanyReportsActivitiesSupplyChainLogisticsRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsRetrieve>>, TError = unknown>(companyReportUuid: string,
    activityUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesSupplyChainLogisticsRetrieveQueryKey(companyReportUuid,activityUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsRetrieve>>> = ({ signal }) => companyReportsActivitiesSupplyChainLogisticsRetrieve(companyReportUuid,activityUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid && activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesSupplyChainLogisticsRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsRetrieve>>>
export type CompanyReportsActivitiesSupplyChainLogisticsRetrieveInfiniteQueryError = unknown

export const useCompanyReportsActivitiesSupplyChainLogisticsRetrieveInfinite = <TData = Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    activityUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesSupplyChainLogisticsRetrieveInfiniteQueryOptions(companyReportUuid,activityUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsActivitiesSupplyChainLogisticsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsRetrieve>>, TError = unknown>(companyReportUuid: string,
    activityUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesSupplyChainLogisticsRetrieveQueryKey(companyReportUuid,activityUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsRetrieve>>> = ({ signal }) => companyReportsActivitiesSupplyChainLogisticsRetrieve(companyReportUuid,activityUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid && activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesSupplyChainLogisticsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsRetrieve>>>
export type CompanyReportsActivitiesSupplyChainLogisticsRetrieveQueryError = unknown

export const useCompanyReportsActivitiesSupplyChainLogisticsRetrieve = <TData = Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    activityUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesSupplyChainLogisticsRetrieveQueryOptions(companyReportUuid,activityUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsActivitiesSupplyChainLogisticsUpdate = (
    companyReportUuid: string,
    activityUuid: string,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ActivityUpdateResponse>(
      {url: `/company-reports/${companyReportUuid}/activities/supply-chain-logistics/${activityUuid}`, method: 'PUT'
    },
      options);
    }
  


export const getCompanyReportsActivitiesSupplyChainLogisticsUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsUpdate>>, TError,{companyReportUuid: string;activityUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsUpdate>>, TError,{companyReportUuid: string;activityUuid: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsUpdate>>, {companyReportUuid: string;activityUuid: string}> = (props) => {
          const {companyReportUuid,activityUuid} = props ?? {};

          return  companyReportsActivitiesSupplyChainLogisticsUpdate(companyReportUuid,activityUuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsActivitiesSupplyChainLogisticsUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsUpdate>>>
    
    export type CompanyReportsActivitiesSupplyChainLogisticsUpdateMutationError = unknown

    export const useCompanyReportsActivitiesSupplyChainLogisticsUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsUpdate>>, TError,{companyReportUuid: string;activityUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsUpdate>>,
        TError,
        {companyReportUuid: string;activityUuid: string},
        TContext
      > => {

      const mutationOptions = getCompanyReportsActivitiesSupplyChainLogisticsUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsActivitiesSupplyChainLogisticsPreviewRetrieve = (
    companyReportUuid: string,
    params?: CompanyReportsActivitiesSupplyChainLogisticsPreviewRetrieveParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<SupplyChainLogisticsPreviewResults>(
      {url: `/company-reports/${companyReportUuid}/activities/supply-chain-logistics/preview`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCompanyReportsActivitiesSupplyChainLogisticsPreviewRetrieveQueryKey = (companyReportUuid: string,
    params?: CompanyReportsActivitiesSupplyChainLogisticsPreviewRetrieveParams,) => {
    return [`/company-reports/${companyReportUuid}/activities/supply-chain-logistics/preview`, ...(params ? [params]: [])] as const;
    }

    
export const getCompanyReportsActivitiesSupplyChainLogisticsPreviewRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsPreviewRetrieve>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesSupplyChainLogisticsPreviewRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesSupplyChainLogisticsPreviewRetrieveQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsPreviewRetrieve>>> = ({ signal, pageParam }) => companyReportsActivitiesSupplyChainLogisticsPreviewRetrieve(companyReportUuid,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsPreviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesSupplyChainLogisticsPreviewRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsPreviewRetrieve>>>
export type CompanyReportsActivitiesSupplyChainLogisticsPreviewRetrieveInfiniteQueryError = unknown

export const useCompanyReportsActivitiesSupplyChainLogisticsPreviewRetrieveInfinite = <TData = Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsPreviewRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesSupplyChainLogisticsPreviewRetrieveParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesSupplyChainLogisticsPreviewRetrieveInfiniteQueryOptions(companyReportUuid,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsActivitiesSupplyChainLogisticsPreviewRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsPreviewRetrieve>>, TError = unknown>(companyReportUuid: string,
    params?: CompanyReportsActivitiesSupplyChainLogisticsPreviewRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivitiesSupplyChainLogisticsPreviewRetrieveQueryKey(companyReportUuid,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsPreviewRetrieve>>> = ({ signal }) => companyReportsActivitiesSupplyChainLogisticsPreviewRetrieve(companyReportUuid,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsPreviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivitiesSupplyChainLogisticsPreviewRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsPreviewRetrieve>>>
export type CompanyReportsActivitiesSupplyChainLogisticsPreviewRetrieveQueryError = unknown

export const useCompanyReportsActivitiesSupplyChainLogisticsPreviewRetrieve = <TData = Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsPreviewRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    params?: CompanyReportsActivitiesSupplyChainLogisticsPreviewRetrieveParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivitiesSupplyChainLogisticsPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivitiesSupplyChainLogisticsPreviewRetrieveQueryOptions(companyReportUuid,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsCategoryStatusUpdate = (
    companyReportUuid: string,
    companyReportCategoryStatus: NonReadonly<CompanyReportCategoryStatus>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<CompanyReportCategoryStatus>(
      {url: `/company-reports/${companyReportUuid}/category-status`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: companyReportCategoryStatus
    },
      options);
    }
  


export const getCompanyReportsCategoryStatusUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsCategoryStatusUpdate>>, TError,{companyReportUuid: string;data: NonReadonly<CompanyReportCategoryStatus>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsCategoryStatusUpdate>>, TError,{companyReportUuid: string;data: NonReadonly<CompanyReportCategoryStatus>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsCategoryStatusUpdate>>, {companyReportUuid: string;data: NonReadonly<CompanyReportCategoryStatus>}> = (props) => {
          const {companyReportUuid,data} = props ?? {};

          return  companyReportsCategoryStatusUpdate(companyReportUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsCategoryStatusUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsCategoryStatusUpdate>>>
    export type CompanyReportsCategoryStatusUpdateMutationBody = NonReadonly<CompanyReportCategoryStatus>
    export type CompanyReportsCategoryStatusUpdateMutationError = unknown

    export const useCompanyReportsCategoryStatusUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsCategoryStatusUpdate>>, TError,{companyReportUuid: string;data: NonReadonly<CompanyReportCategoryStatus>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsCategoryStatusUpdate>>,
        TError,
        {companyReportUuid: string;data: NonReadonly<CompanyReportCategoryStatus>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsCategoryStatusUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsOtherActivitiesList = (
    companyReportUuid: string,
    activityTypeSlug: string,
    params?: CompanyReportsOtherActivitiesListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedOtherActivitiesListList>(
      {url: `/company-reports/${companyReportUuid}/other-activities/${activityTypeSlug}`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCompanyReportsOtherActivitiesListQueryKey = (companyReportUuid: string,
    activityTypeSlug: string,
    params?: CompanyReportsOtherActivitiesListParams,) => {
    return [`/company-reports/${companyReportUuid}/other-activities/${activityTypeSlug}`, ...(params ? [params]: [])] as const;
    }

    
export const getCompanyReportsOtherActivitiesListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsOtherActivitiesList>>, TError = unknown>(companyReportUuid: string,
    activityTypeSlug: string,
    params?: CompanyReportsOtherActivitiesListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsOtherActivitiesList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsOtherActivitiesListQueryKey(companyReportUuid,activityTypeSlug,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsOtherActivitiesList>>> = ({ signal, pageParam }) => companyReportsOtherActivitiesList(companyReportUuid,activityTypeSlug,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid && activityTypeSlug),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsOtherActivitiesList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsOtherActivitiesListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsOtherActivitiesList>>>
export type CompanyReportsOtherActivitiesListInfiniteQueryError = unknown

export const useCompanyReportsOtherActivitiesListInfinite = <TData = Awaited<ReturnType<typeof companyReportsOtherActivitiesList>>, TError = unknown>(
 companyReportUuid: string,
    activityTypeSlug: string,
    params?: CompanyReportsOtherActivitiesListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsOtherActivitiesList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsOtherActivitiesListInfiniteQueryOptions(companyReportUuid,activityTypeSlug,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsOtherActivitiesListQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsOtherActivitiesList>>, TError = unknown>(companyReportUuid: string,
    activityTypeSlug: string,
    params?: CompanyReportsOtherActivitiesListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsOtherActivitiesList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsOtherActivitiesListQueryKey(companyReportUuid,activityTypeSlug,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsOtherActivitiesList>>> = ({ signal }) => companyReportsOtherActivitiesList(companyReportUuid,activityTypeSlug,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid && activityTypeSlug),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsOtherActivitiesList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsOtherActivitiesListQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsOtherActivitiesList>>>
export type CompanyReportsOtherActivitiesListQueryError = unknown

export const useCompanyReportsOtherActivitiesList = <TData = Awaited<ReturnType<typeof companyReportsOtherActivitiesList>>, TError = unknown>(
 companyReportUuid: string,
    activityTypeSlug: string,
    params?: CompanyReportsOtherActivitiesListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsOtherActivitiesList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsOtherActivitiesListQueryOptions(companyReportUuid,activityTypeSlug,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsOtherActivitiesCreate = (
    companyReportUuid: string,
    activityTypeSlug: string,
    otherActivity: NonReadonly<OtherActivity>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<OtherActivity>(
      {url: `/company-reports/${companyReportUuid}/other-activities/${activityTypeSlug}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: otherActivity
    },
      options);
    }
  


export const getCompanyReportsOtherActivitiesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsOtherActivitiesCreate>>, TError,{companyReportUuid: string;activityTypeSlug: string;data: NonReadonly<OtherActivity>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsOtherActivitiesCreate>>, TError,{companyReportUuid: string;activityTypeSlug: string;data: NonReadonly<OtherActivity>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsOtherActivitiesCreate>>, {companyReportUuid: string;activityTypeSlug: string;data: NonReadonly<OtherActivity>}> = (props) => {
          const {companyReportUuid,activityTypeSlug,data} = props ?? {};

          return  companyReportsOtherActivitiesCreate(companyReportUuid,activityTypeSlug,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsOtherActivitiesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsOtherActivitiesCreate>>>
    export type CompanyReportsOtherActivitiesCreateMutationBody = NonReadonly<OtherActivity>
    export type CompanyReportsOtherActivitiesCreateMutationError = unknown

    export const useCompanyReportsOtherActivitiesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsOtherActivitiesCreate>>, TError,{companyReportUuid: string;activityTypeSlug: string;data: NonReadonly<OtherActivity>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsOtherActivitiesCreate>>,
        TError,
        {companyReportUuid: string;activityTypeSlug: string;data: NonReadonly<OtherActivity>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsOtherActivitiesCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsOtherActivitiesRetrieve = (
    companyReportUuid: string,
    activityTypeSlug: string,
    activityUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<OtherActivityRetrieve>(
      {url: `/company-reports/${companyReportUuid}/other-activities/${activityTypeSlug}/${activityUuid}`, method: 'GET', signal
    },
      options);
    }
  

export const getCompanyReportsOtherActivitiesRetrieveQueryKey = (companyReportUuid: string,
    activityTypeSlug: string,
    activityUuid: string,) => {
    return [`/company-reports/${companyReportUuid}/other-activities/${activityTypeSlug}/${activityUuid}`] as const;
    }

    
export const getCompanyReportsOtherActivitiesRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsOtherActivitiesRetrieve>>, TError = unknown>(companyReportUuid: string,
    activityTypeSlug: string,
    activityUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsOtherActivitiesRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsOtherActivitiesRetrieveQueryKey(companyReportUuid,activityTypeSlug,activityUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsOtherActivitiesRetrieve>>> = ({ signal }) => companyReportsOtherActivitiesRetrieve(companyReportUuid,activityTypeSlug,activityUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid && activityTypeSlug && activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsOtherActivitiesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsOtherActivitiesRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsOtherActivitiesRetrieve>>>
export type CompanyReportsOtherActivitiesRetrieveInfiniteQueryError = unknown

export const useCompanyReportsOtherActivitiesRetrieveInfinite = <TData = Awaited<ReturnType<typeof companyReportsOtherActivitiesRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    activityTypeSlug: string,
    activityUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsOtherActivitiesRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsOtherActivitiesRetrieveInfiniteQueryOptions(companyReportUuid,activityTypeSlug,activityUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsOtherActivitiesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsOtherActivitiesRetrieve>>, TError = unknown>(companyReportUuid: string,
    activityTypeSlug: string,
    activityUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsOtherActivitiesRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsOtherActivitiesRetrieveQueryKey(companyReportUuid,activityTypeSlug,activityUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsOtherActivitiesRetrieve>>> = ({ signal }) => companyReportsOtherActivitiesRetrieve(companyReportUuid,activityTypeSlug,activityUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid && activityTypeSlug && activityUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsOtherActivitiesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsOtherActivitiesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsOtherActivitiesRetrieve>>>
export type CompanyReportsOtherActivitiesRetrieveQueryError = unknown

export const useCompanyReportsOtherActivitiesRetrieve = <TData = Awaited<ReturnType<typeof companyReportsOtherActivitiesRetrieve>>, TError = unknown>(
 companyReportUuid: string,
    activityTypeSlug: string,
    activityUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsOtherActivitiesRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsOtherActivitiesRetrieveQueryOptions(companyReportUuid,activityTypeSlug,activityUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsOtherActivitiesUpdate = (
    companyReportUuid: string,
    activityTypeSlug: string,
    activityUuid: string,
    otherActivity: NonReadonly<OtherActivity>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ActivityUpdateResponse>(
      {url: `/company-reports/${companyReportUuid}/other-activities/${activityTypeSlug}/${activityUuid}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: otherActivity
    },
      options);
    }
  


export const getCompanyReportsOtherActivitiesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsOtherActivitiesUpdate>>, TError,{companyReportUuid: string;activityTypeSlug: string;activityUuid: string;data: NonReadonly<OtherActivity>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsOtherActivitiesUpdate>>, TError,{companyReportUuid: string;activityTypeSlug: string;activityUuid: string;data: NonReadonly<OtherActivity>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsOtherActivitiesUpdate>>, {companyReportUuid: string;activityTypeSlug: string;activityUuid: string;data: NonReadonly<OtherActivity>}> = (props) => {
          const {companyReportUuid,activityTypeSlug,activityUuid,data} = props ?? {};

          return  companyReportsOtherActivitiesUpdate(companyReportUuid,activityTypeSlug,activityUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsOtherActivitiesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsOtherActivitiesUpdate>>>
    export type CompanyReportsOtherActivitiesUpdateMutationBody = NonReadonly<OtherActivity>
    export type CompanyReportsOtherActivitiesUpdateMutationError = unknown

    export const useCompanyReportsOtherActivitiesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsOtherActivitiesUpdate>>, TError,{companyReportUuid: string;activityTypeSlug: string;activityUuid: string;data: NonReadonly<OtherActivity>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsOtherActivitiesUpdate>>,
        TError,
        {companyReportUuid: string;activityTypeSlug: string;activityUuid: string;data: NonReadonly<OtherActivity>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsOtherActivitiesUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsPreviewRetrieve = (
    companyReportUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<CompanyReportPreviewResults>(
      {url: `/company-reports/${companyReportUuid}/preview`, method: 'GET', signal
    },
      options);
    }
  

export const getCompanyReportsPreviewRetrieveQueryKey = (companyReportUuid: string,) => {
    return [`/company-reports/${companyReportUuid}/preview`] as const;
    }

    
export const getCompanyReportsPreviewRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsPreviewRetrieve>>, TError = unknown>(companyReportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsPreviewRetrieveQueryKey(companyReportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsPreviewRetrieve>>> = ({ signal }) => companyReportsPreviewRetrieve(companyReportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsPreviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsPreviewRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsPreviewRetrieve>>>
export type CompanyReportsPreviewRetrieveInfiniteQueryError = unknown

export const useCompanyReportsPreviewRetrieveInfinite = <TData = Awaited<ReturnType<typeof companyReportsPreviewRetrieve>>, TError = unknown>(
 companyReportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsPreviewRetrieveInfiniteQueryOptions(companyReportUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsPreviewRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsPreviewRetrieve>>, TError = unknown>(companyReportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsPreviewRetrieveQueryKey(companyReportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsPreviewRetrieve>>> = ({ signal }) => companyReportsPreviewRetrieve(companyReportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsPreviewRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsPreviewRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsPreviewRetrieve>>>
export type CompanyReportsPreviewRetrieveQueryError = unknown

export const useCompanyReportsPreviewRetrieve = <TData = Awaited<ReturnType<typeof companyReportsPreviewRetrieve>>, TError = unknown>(
 companyReportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsPreviewRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsPreviewRetrieveQueryOptions(companyReportUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsPublishCreate = (
    companyReportUuid: string,
    companyReportCategoryStatus: NonReadonly<CompanyReportCategoryStatus[]>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<CompanyReportPublishResponse>(
      {url: `/company-reports/${companyReportUuid}/publish`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: companyReportCategoryStatus
    },
      options);
    }
  


export const getCompanyReportsPublishCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsPublishCreate>>, TError,{companyReportUuid: string;data: NonReadonly<CompanyReportCategoryStatus[]>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsPublishCreate>>, TError,{companyReportUuid: string;data: NonReadonly<CompanyReportCategoryStatus[]>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsPublishCreate>>, {companyReportUuid: string;data: NonReadonly<CompanyReportCategoryStatus[]>}> = (props) => {
          const {companyReportUuid,data} = props ?? {};

          return  companyReportsPublishCreate(companyReportUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsPublishCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsPublishCreate>>>
    export type CompanyReportsPublishCreateMutationBody = NonReadonly<CompanyReportCategoryStatus[]>
    export type CompanyReportsPublishCreateMutationError = unknown

    export const useCompanyReportsPublishCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsPublishCreate>>, TError,{companyReportUuid: string;data: NonReadonly<CompanyReportCategoryStatus[]>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsPublishCreate>>,
        TError,
        {companyReportUuid: string;data: NonReadonly<CompanyReportCategoryStatus[]>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsPublishCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Retrieve the latest company report result and construct it manually.
 */
export const companyReportsResultsRetrieve = (
    companyReportUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<CompanyReportResult>(
      {url: `/company-reports/${companyReportUuid}/results`, method: 'GET', signal
    },
      options);
    }
  

export const getCompanyReportsResultsRetrieveQueryKey = (companyReportUuid: string,) => {
    return [`/company-reports/${companyReportUuid}/results`] as const;
    }

    
export const getCompanyReportsResultsRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsResultsRetrieve>>, TError = unknown>(companyReportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsResultsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsResultsRetrieveQueryKey(companyReportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsResultsRetrieve>>> = ({ signal }) => companyReportsResultsRetrieve(companyReportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsResultsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsResultsRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsResultsRetrieve>>>
export type CompanyReportsResultsRetrieveInfiniteQueryError = unknown

export const useCompanyReportsResultsRetrieveInfinite = <TData = Awaited<ReturnType<typeof companyReportsResultsRetrieve>>, TError = unknown>(
 companyReportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsResultsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsResultsRetrieveInfiniteQueryOptions(companyReportUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsResultsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsResultsRetrieve>>, TError = unknown>(companyReportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsResultsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsResultsRetrieveQueryKey(companyReportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsResultsRetrieve>>> = ({ signal }) => companyReportsResultsRetrieve(companyReportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsResultsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsResultsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsResultsRetrieve>>>
export type CompanyReportsResultsRetrieveQueryError = unknown

export const useCompanyReportsResultsRetrieve = <TData = Awaited<ReturnType<typeof companyReportsResultsRetrieve>>, TError = unknown>(
 companyReportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsResultsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsResultsRetrieveQueryOptions(companyReportUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsResultsDownloadRetrieve = (
    companyReportUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<ReportResultDownload>(
      {url: `/company-reports/${companyReportUuid}/results/download`, method: 'GET', signal
    },
      options);
    }
  

export const getCompanyReportsResultsDownloadRetrieveQueryKey = (companyReportUuid: string,) => {
    return [`/company-reports/${companyReportUuid}/results/download`] as const;
    }

    
export const getCompanyReportsResultsDownloadRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsResultsDownloadRetrieve>>, TError = unknown>(companyReportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsResultsDownloadRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsResultsDownloadRetrieveQueryKey(companyReportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsResultsDownloadRetrieve>>> = ({ signal }) => companyReportsResultsDownloadRetrieve(companyReportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsResultsDownloadRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsResultsDownloadRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsResultsDownloadRetrieve>>>
export type CompanyReportsResultsDownloadRetrieveInfiniteQueryError = unknown

export const useCompanyReportsResultsDownloadRetrieveInfinite = <TData = Awaited<ReturnType<typeof companyReportsResultsDownloadRetrieve>>, TError = unknown>(
 companyReportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsResultsDownloadRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsResultsDownloadRetrieveInfiniteQueryOptions(companyReportUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsResultsDownloadRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsResultsDownloadRetrieve>>, TError = unknown>(companyReportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsResultsDownloadRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsResultsDownloadRetrieveQueryKey(companyReportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsResultsDownloadRetrieve>>> = ({ signal }) => companyReportsResultsDownloadRetrieve(companyReportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsResultsDownloadRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsResultsDownloadRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsResultsDownloadRetrieve>>>
export type CompanyReportsResultsDownloadRetrieveQueryError = unknown

export const useCompanyReportsResultsDownloadRetrieve = <TData = Awaited<ReturnType<typeof companyReportsResultsDownloadRetrieve>>, TError = unknown>(
 companyReportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsResultsDownloadRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsResultsDownloadRetrieveQueryOptions(companyReportUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * GET / PUT / PATCH /reports/<uuid>/secr-config — manage SECR config on a report.
 */
export const companyReportsSecrConfigRetrieve = (
    companyReportUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<SECRReportConfig>(
      {url: `/company-reports/${companyReportUuid}/secr-config`, method: 'GET', signal
    },
      options);
    }
  

export const getCompanyReportsSecrConfigRetrieveQueryKey = (companyReportUuid: string,) => {
    return [`/company-reports/${companyReportUuid}/secr-config`] as const;
    }

    
export const getCompanyReportsSecrConfigRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsSecrConfigRetrieve>>, TError = unknown>(companyReportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsSecrConfigRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsSecrConfigRetrieveQueryKey(companyReportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsSecrConfigRetrieve>>> = ({ signal }) => companyReportsSecrConfigRetrieve(companyReportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsSecrConfigRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsSecrConfigRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsSecrConfigRetrieve>>>
export type CompanyReportsSecrConfigRetrieveInfiniteQueryError = unknown

export const useCompanyReportsSecrConfigRetrieveInfinite = <TData = Awaited<ReturnType<typeof companyReportsSecrConfigRetrieve>>, TError = unknown>(
 companyReportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsSecrConfigRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsSecrConfigRetrieveInfiniteQueryOptions(companyReportUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsSecrConfigRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsSecrConfigRetrieve>>, TError = unknown>(companyReportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsSecrConfigRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsSecrConfigRetrieveQueryKey(companyReportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsSecrConfigRetrieve>>> = ({ signal }) => companyReportsSecrConfigRetrieve(companyReportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsSecrConfigRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsSecrConfigRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsSecrConfigRetrieve>>>
export type CompanyReportsSecrConfigRetrieveQueryError = unknown

export const useCompanyReportsSecrConfigRetrieve = <TData = Awaited<ReturnType<typeof companyReportsSecrConfigRetrieve>>, TError = unknown>(
 companyReportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsSecrConfigRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsSecrConfigRetrieveQueryOptions(companyReportUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * GET / PUT / PATCH /reports/<uuid>/secr-config — manage SECR config on a report.
 */
export const companyReportsSecrConfigUpdate = (
    companyReportUuid: string,
    sECRReportConfig: NonReadonly<SECRReportConfig>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<SECRReportConfig>(
      {url: `/company-reports/${companyReportUuid}/secr-config`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: sECRReportConfig
    },
      options);
    }
  


export const getCompanyReportsSecrConfigUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSecrConfigUpdate>>, TError,{companyReportUuid: string;data: NonReadonly<SECRReportConfig>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsSecrConfigUpdate>>, TError,{companyReportUuid: string;data: NonReadonly<SECRReportConfig>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsSecrConfigUpdate>>, {companyReportUuid: string;data: NonReadonly<SECRReportConfig>}> = (props) => {
          const {companyReportUuid,data} = props ?? {};

          return  companyReportsSecrConfigUpdate(companyReportUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsSecrConfigUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsSecrConfigUpdate>>>
    export type CompanyReportsSecrConfigUpdateMutationBody = NonReadonly<SECRReportConfig>
    export type CompanyReportsSecrConfigUpdateMutationError = unknown

    export const useCompanyReportsSecrConfigUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSecrConfigUpdate>>, TError,{companyReportUuid: string;data: NonReadonly<SECRReportConfig>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsSecrConfigUpdate>>,
        TError,
        {companyReportUuid: string;data: NonReadonly<SECRReportConfig>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsSecrConfigUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * GET / PUT / PATCH /reports/<uuid>/secr-config — manage SECR config on a report.
 */
export const companyReportsSecrConfigPartialUpdate = (
    companyReportUuid: string,
    patchedSECRReportConfig: NonReadonly<PatchedSECRReportConfig>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<SECRReportConfig>(
      {url: `/company-reports/${companyReportUuid}/secr-config`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedSECRReportConfig
    },
      options);
    }
  


export const getCompanyReportsSecrConfigPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSecrConfigPartialUpdate>>, TError,{companyReportUuid: string;data: NonReadonly<PatchedSECRReportConfig>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsSecrConfigPartialUpdate>>, TError,{companyReportUuid: string;data: NonReadonly<PatchedSECRReportConfig>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsSecrConfigPartialUpdate>>, {companyReportUuid: string;data: NonReadonly<PatchedSECRReportConfig>}> = (props) => {
          const {companyReportUuid,data} = props ?? {};

          return  companyReportsSecrConfigPartialUpdate(companyReportUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsSecrConfigPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsSecrConfigPartialUpdate>>>
    export type CompanyReportsSecrConfigPartialUpdateMutationBody = NonReadonly<PatchedSECRReportConfig>
    export type CompanyReportsSecrConfigPartialUpdateMutationError = unknown

    export const useCompanyReportsSecrConfigPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSecrConfigPartialUpdate>>, TError,{companyReportUuid: string;data: NonReadonly<PatchedSECRReportConfig>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsSecrConfigPartialUpdate>>,
        TError,
        {companyReportUuid: string;data: NonReadonly<PatchedSECRReportConfig>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsSecrConfigPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * GET /reports/<uuid>/secr-results — aggregated SECR figures + comparison.
 */
export const companyReportsSecrResultsRetrieve = (
    companyReportUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<SECRReportResult>(
      {url: `/company-reports/${companyReportUuid}/secr-results`, method: 'GET', signal
    },
      options);
    }
  

export const getCompanyReportsSecrResultsRetrieveQueryKey = (companyReportUuid: string,) => {
    return [`/company-reports/${companyReportUuid}/secr-results`] as const;
    }

    
export const getCompanyReportsSecrResultsRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsSecrResultsRetrieve>>, TError = unknown>(companyReportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsSecrResultsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsSecrResultsRetrieveQueryKey(companyReportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsSecrResultsRetrieve>>> = ({ signal }) => companyReportsSecrResultsRetrieve(companyReportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsSecrResultsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsSecrResultsRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsSecrResultsRetrieve>>>
export type CompanyReportsSecrResultsRetrieveInfiniteQueryError = unknown

export const useCompanyReportsSecrResultsRetrieveInfinite = <TData = Awaited<ReturnType<typeof companyReportsSecrResultsRetrieve>>, TError = unknown>(
 companyReportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsSecrResultsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsSecrResultsRetrieveInfiniteQueryOptions(companyReportUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsSecrResultsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsSecrResultsRetrieve>>, TError = unknown>(companyReportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsSecrResultsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsSecrResultsRetrieveQueryKey(companyReportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsSecrResultsRetrieve>>> = ({ signal }) => companyReportsSecrResultsRetrieve(companyReportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsSecrResultsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsSecrResultsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsSecrResultsRetrieve>>>
export type CompanyReportsSecrResultsRetrieveQueryError = unknown

export const useCompanyReportsSecrResultsRetrieve = <TData = Awaited<ReturnType<typeof companyReportsSecrResultsRetrieve>>, TError = unknown>(
 companyReportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsSecrResultsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsSecrResultsRetrieveQueryOptions(companyReportUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsTimePeriodsList = (
    companyReportUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<TimePeriod[]>(
      {url: `/company-reports/${companyReportUuid}/time-periods`, method: 'GET', signal
    },
      options);
    }
  

export const getCompanyReportsTimePeriodsListQueryKey = (companyReportUuid: string,) => {
    return [`/company-reports/${companyReportUuid}/time-periods`] as const;
    }

    
export const getCompanyReportsTimePeriodsListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsTimePeriodsList>>, TError = unknown>(companyReportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsTimePeriodsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsTimePeriodsListQueryKey(companyReportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsTimePeriodsList>>> = ({ signal }) => companyReportsTimePeriodsList(companyReportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsTimePeriodsList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsTimePeriodsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsTimePeriodsList>>>
export type CompanyReportsTimePeriodsListInfiniteQueryError = unknown

export const useCompanyReportsTimePeriodsListInfinite = <TData = Awaited<ReturnType<typeof companyReportsTimePeriodsList>>, TError = unknown>(
 companyReportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsTimePeriodsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsTimePeriodsListInfiniteQueryOptions(companyReportUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsTimePeriodsListQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsTimePeriodsList>>, TError = unknown>(companyReportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsTimePeriodsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsTimePeriodsListQueryKey(companyReportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsTimePeriodsList>>> = ({ signal }) => companyReportsTimePeriodsList(companyReportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(companyReportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsTimePeriodsList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsTimePeriodsListQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsTimePeriodsList>>>
export type CompanyReportsTimePeriodsListQueryError = unknown

export const useCompanyReportsTimePeriodsList = <TData = Awaited<ReturnType<typeof companyReportsTimePeriodsList>>, TError = unknown>(
 companyReportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsTimePeriodsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsTimePeriodsListQueryOptions(companyReportUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsActivityTypesUnitsList = (
    activityTypeSlug: string,
    params?: CompanyReportsActivityTypesUnitsListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<ActivityUnit[]>(
      {url: `/company-reports/activity-types/${activityTypeSlug}/units`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCompanyReportsActivityTypesUnitsListQueryKey = (activityTypeSlug: string,
    params?: CompanyReportsActivityTypesUnitsListParams,) => {
    return [`/company-reports/activity-types/${activityTypeSlug}/units`, ...(params ? [params]: [])] as const;
    }

    
export const getCompanyReportsActivityTypesUnitsListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivityTypesUnitsList>>, TError = unknown>(activityTypeSlug: string,
    params?: CompanyReportsActivityTypesUnitsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivityTypesUnitsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivityTypesUnitsListQueryKey(activityTypeSlug,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivityTypesUnitsList>>> = ({ signal, pageParam }) => companyReportsActivityTypesUnitsList(activityTypeSlug,{...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityTypeSlug),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivityTypesUnitsList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivityTypesUnitsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivityTypesUnitsList>>>
export type CompanyReportsActivityTypesUnitsListInfiniteQueryError = unknown

export const useCompanyReportsActivityTypesUnitsListInfinite = <TData = Awaited<ReturnType<typeof companyReportsActivityTypesUnitsList>>, TError = unknown>(
 activityTypeSlug: string,
    params?: CompanyReportsActivityTypesUnitsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsActivityTypesUnitsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivityTypesUnitsListInfiniteQueryOptions(activityTypeSlug,params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsActivityTypesUnitsListQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsActivityTypesUnitsList>>, TError = unknown>(activityTypeSlug: string,
    params?: CompanyReportsActivityTypesUnitsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivityTypesUnitsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsActivityTypesUnitsListQueryKey(activityTypeSlug,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsActivityTypesUnitsList>>> = ({ signal }) => companyReportsActivityTypesUnitsList(activityTypeSlug,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityTypeSlug),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivityTypesUnitsList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsActivityTypesUnitsListQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsActivityTypesUnitsList>>>
export type CompanyReportsActivityTypesUnitsListQueryError = unknown

export const useCompanyReportsActivityTypesUnitsList = <TData = Awaited<ReturnType<typeof companyReportsActivityTypesUnitsList>>, TError = unknown>(
 activityTypeSlug: string,
    params?: CompanyReportsActivityTypesUnitsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsActivityTypesUnitsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsActivityTypesUnitsListQueryOptions(activityTypeSlug,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsFuelsList = (
    params?: CompanyReportsFuelsListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<ActivityFuel[]>(
      {url: `/company-reports/fuels`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCompanyReportsFuelsListQueryKey = (params?: CompanyReportsFuelsListParams,) => {
    return [`/company-reports/fuels`, ...(params ? [params]: [])] as const;
    }

    
export const getCompanyReportsFuelsListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsFuelsList>>, TError = unknown>(params?: CompanyReportsFuelsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsFuelsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsFuelsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsFuelsList>>> = ({ signal, pageParam }) => companyReportsFuelsList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsFuelsList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsFuelsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsFuelsList>>>
export type CompanyReportsFuelsListInfiniteQueryError = unknown

export const useCompanyReportsFuelsListInfinite = <TData = Awaited<ReturnType<typeof companyReportsFuelsList>>, TError = unknown>(
 params?: CompanyReportsFuelsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsFuelsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsFuelsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsFuelsListQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsFuelsList>>, TError = unknown>(params?: CompanyReportsFuelsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsFuelsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsFuelsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsFuelsList>>> = ({ signal }) => companyReportsFuelsList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsFuelsList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsFuelsListQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsFuelsList>>>
export type CompanyReportsFuelsListQueryError = unknown

export const useCompanyReportsFuelsList = <TData = Awaited<ReturnType<typeof companyReportsFuelsList>>, TError = unknown>(
 params?: CompanyReportsFuelsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsFuelsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsFuelsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsGasesList = (
    params?: CompanyReportsGasesListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<ActivityGas[]>(
      {url: `/company-reports/gases`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCompanyReportsGasesListQueryKey = (params?: CompanyReportsGasesListParams,) => {
    return [`/company-reports/gases`, ...(params ? [params]: [])] as const;
    }

    
export const getCompanyReportsGasesListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsGasesList>>, TError = unknown>(params?: CompanyReportsGasesListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsGasesList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsGasesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsGasesList>>> = ({ signal, pageParam }) => companyReportsGasesList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsGasesList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsGasesListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsGasesList>>>
export type CompanyReportsGasesListInfiniteQueryError = unknown

export const useCompanyReportsGasesListInfinite = <TData = Awaited<ReturnType<typeof companyReportsGasesList>>, TError = unknown>(
 params?: CompanyReportsGasesListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsGasesList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsGasesListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsGasesListQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsGasesList>>, TError = unknown>(params?: CompanyReportsGasesListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsGasesList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsGasesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsGasesList>>> = ({ signal }) => companyReportsGasesList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsGasesList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsGasesListQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsGasesList>>>
export type CompanyReportsGasesListQueryError = unknown

export const useCompanyReportsGasesList = <TData = Awaited<ReturnType<typeof companyReportsGasesList>>, TError = unknown>(
 params?: CompanyReportsGasesListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsGasesList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsGasesListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * List the organisation's purchased or sold goods imports.
 */
export const companyReportsImportsList = (
    params?: CompanyReportsImportsListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedActivityImportListList>(
      {url: `/company-reports/imports`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCompanyReportsImportsListQueryKey = (params?: CompanyReportsImportsListParams,) => {
    return [`/company-reports/imports`, ...(params ? [params]: [])] as const;
    }

    
export const getCompanyReportsImportsListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsImportsList>>, TError = unknown>(params?: CompanyReportsImportsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsImportsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsImportsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsImportsList>>> = ({ signal, pageParam }) => companyReportsImportsList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsImportsList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsImportsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsImportsList>>>
export type CompanyReportsImportsListInfiniteQueryError = unknown

export const useCompanyReportsImportsListInfinite = <TData = Awaited<ReturnType<typeof companyReportsImportsList>>, TError = unknown>(
 params?: CompanyReportsImportsListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsImportsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsImportsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsImportsListQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsImportsList>>, TError = unknown>(params?: CompanyReportsImportsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsImportsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsImportsListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsImportsList>>> = ({ signal }) => companyReportsImportsList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsImportsList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsImportsListQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsImportsList>>>
export type CompanyReportsImportsListQueryError = unknown

export const useCompanyReportsImportsList = <TData = Awaited<ReturnType<typeof companyReportsImportsList>>, TError = unknown>(
 params?: CompanyReportsImportsListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsImportsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsImportsListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Retrieve a single import.
 */
export const activityImportsRetrieve = (
    activityImportUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<ActivityImportRetrieveUpdate>(
      {url: `/company-reports/imports/${activityImportUuid}`, method: 'GET', signal
    },
      options);
    }
  

export const getActivityImportsRetrieveQueryKey = (activityImportUuid: string,) => {
    return [`/company-reports/imports/${activityImportUuid}`] as const;
    }

    
export const getActivityImportsRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof activityImportsRetrieve>>, TError = unknown>(activityImportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof activityImportsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityImportsRetrieveQueryKey(activityImportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityImportsRetrieve>>> = ({ signal }) => activityImportsRetrieve(activityImportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityImportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof activityImportsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ActivityImportsRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof activityImportsRetrieve>>>
export type ActivityImportsRetrieveInfiniteQueryError = unknown

export const useActivityImportsRetrieveInfinite = <TData = Awaited<ReturnType<typeof activityImportsRetrieve>>, TError = unknown>(
 activityImportUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof activityImportsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getActivityImportsRetrieveInfiniteQueryOptions(activityImportUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getActivityImportsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof activityImportsRetrieve>>, TError = unknown>(activityImportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof activityImportsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityImportsRetrieveQueryKey(activityImportUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityImportsRetrieve>>> = ({ signal }) => activityImportsRetrieve(activityImportUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(activityImportUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityImportsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type ActivityImportsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof activityImportsRetrieve>>>
export type ActivityImportsRetrieveQueryError = unknown

export const useActivityImportsRetrieve = <TData = Awaited<ReturnType<typeof activityImportsRetrieve>>, TError = unknown>(
 activityImportUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof activityImportsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getActivityImportsRetrieveQueryOptions(activityImportUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Rename an import or change the tags it carries.
 */
export const activityImportsPartialUpdate = (
    activityImportUuid: string,
    patchedActivityImportRetrieveUpdate: NonReadonly<PatchedActivityImportRetrieveUpdate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ActivityImportRetrieveUpdate>(
      {url: `/company-reports/imports/${activityImportUuid}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedActivityImportRetrieveUpdate
    },
      options);
    }
  


export const getActivityImportsPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityImportsPartialUpdate>>, TError,{activityImportUuid: string;data: NonReadonly<PatchedActivityImportRetrieveUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof activityImportsPartialUpdate>>, TError,{activityImportUuid: string;data: NonReadonly<PatchedActivityImportRetrieveUpdate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activityImportsPartialUpdate>>, {activityImportUuid: string;data: NonReadonly<PatchedActivityImportRetrieveUpdate>}> = (props) => {
          const {activityImportUuid,data} = props ?? {};

          return  activityImportsPartialUpdate(activityImportUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ActivityImportsPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof activityImportsPartialUpdate>>>
    export type ActivityImportsPartialUpdateMutationBody = NonReadonly<PatchedActivityImportRetrieveUpdate>
    export type ActivityImportsPartialUpdateMutationError = unknown

    export const useActivityImportsPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityImportsPartialUpdate>>, TError,{activityImportUuid: string;data: NonReadonly<PatchedActivityImportRetrieveUpdate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof activityImportsPartialUpdate>>,
        TError,
        {activityImportUuid: string;data: NonReadonly<PatchedActivityImportRetrieveUpdate>},
        TContext
      > => {

      const mutationOptions = getActivityImportsPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Delete an import and the activities it created.
 */
export const activityImportsDelete = (
    activityImportUuid: string,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<void>(
      {url: `/company-reports/imports/${activityImportUuid}`, method: 'DELETE'
    },
      options);
    }
  


export const getActivityImportsDeleteMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityImportsDelete>>, TError,{activityImportUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof activityImportsDelete>>, TError,{activityImportUuid: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activityImportsDelete>>, {activityImportUuid: string}> = (props) => {
          const {activityImportUuid} = props ?? {};

          return  activityImportsDelete(activityImportUuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ActivityImportsDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof activityImportsDelete>>>
    
    export type ActivityImportsDeleteMutationError = unknown

    export const useActivityImportsDelete = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activityImportsDelete>>, TError,{activityImportUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof activityImportsDelete>>,
        TError,
        {activityImportUuid: string},
        TContext
      > => {

      const mutationOptions = getActivityImportsDeleteMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Admin endpoint to create or return an existing ImportConfig for a file shape.

Idempotent: if a config already matches the (remote_source, import_type,
goods_type, tab_name, header_fingerprint) tuple, returns the existing record
with 200 instead of creating a duplicate.
 */
export const companyReportsImportsConfigsCreate = (
    importConfig: NonReadonly<ImportConfig>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ImportConfig>(
      {url: `/company-reports/imports/configs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: importConfig
    },
      options);
    }
  


export const getCompanyReportsImportsConfigsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsImportsConfigsCreate>>, TError,{data: NonReadonly<ImportConfig>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsImportsConfigsCreate>>, TError,{data: NonReadonly<ImportConfig>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsImportsConfigsCreate>>, {data: NonReadonly<ImportConfig>}> = (props) => {
          const {data} = props ?? {};

          return  companyReportsImportsConfigsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsImportsConfigsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsImportsConfigsCreate>>>
    export type CompanyReportsImportsConfigsCreateMutationBody = NonReadonly<ImportConfig>
    export type CompanyReportsImportsConfigsCreateMutationError = unknown

    export const useCompanyReportsImportsConfigsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsImportsConfigsCreate>>, TError,{data: NonReadonly<ImportConfig>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsImportsConfigsCreate>>,
        TError,
        {data: NonReadonly<ImportConfig>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsImportsConfigsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Process an import via the v2 (item_cleanup_v2) pipeline.
 */
export const companyReportsImportsProcessV2Create = (
    goodsType: string,
    processMixedRows: NonReadonly<ProcessMixedRows>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ActivityImportBase>(
      {url: `/company-reports/imports/process-v2/${goodsType}/`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
      data: processMixedRows
    },
      options);
    }
  


export const getCompanyReportsImportsProcessV2CreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsImportsProcessV2Create>>, TError,{goodsType: string;data: NonReadonly<ProcessMixedRows>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsImportsProcessV2Create>>, TError,{goodsType: string;data: NonReadonly<ProcessMixedRows>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsImportsProcessV2Create>>, {goodsType: string;data: NonReadonly<ProcessMixedRows>}> = (props) => {
          const {goodsType,data} = props ?? {};

          return  companyReportsImportsProcessV2Create(goodsType,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsImportsProcessV2CreateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsImportsProcessV2Create>>>
    export type CompanyReportsImportsProcessV2CreateMutationBody = NonReadonly<ProcessMixedRows>
    export type CompanyReportsImportsProcessV2CreateMutationError = unknown

    export const useCompanyReportsImportsProcessV2Create = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsImportsProcessV2Create>>, TError,{goodsType: string;data: NonReadonly<ProcessMixedRows>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsImportsProcessV2Create>>,
        TError,
        {goodsType: string;data: NonReadonly<ProcessMixedRows>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsImportsProcessV2CreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Handles synchronous imports for electricity, heat, stationary-combustion,
mobile-combustion, and direct-gas-emissions. Accepts either a JSON body or
multipart/form-data with an optional uploaded_file (no RQ queue). Each row is
processed directly through the appropriate EmissionService, and the created
activity records are linked to the import. The entire batch is atomic — any
failure rolls back all rows.
 */
export const companyReportsImportsProcessDirectGasEmissionsCreate = (
    processDirectGasEmissionsRows: NonReadonly<ProcessDirectGasEmissionsRows>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ProcessDirectGasEmissionsRows>(
      {url: `/company-reports/imports/process/direct-gas-emissions`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
      data: processDirectGasEmissionsRows
    },
      options);
    }
  


export const getCompanyReportsImportsProcessDirectGasEmissionsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsImportsProcessDirectGasEmissionsCreate>>, TError,{data: NonReadonly<ProcessDirectGasEmissionsRows>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsImportsProcessDirectGasEmissionsCreate>>, TError,{data: NonReadonly<ProcessDirectGasEmissionsRows>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsImportsProcessDirectGasEmissionsCreate>>, {data: NonReadonly<ProcessDirectGasEmissionsRows>}> = (props) => {
          const {data} = props ?? {};

          return  companyReportsImportsProcessDirectGasEmissionsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsImportsProcessDirectGasEmissionsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsImportsProcessDirectGasEmissionsCreate>>>
    export type CompanyReportsImportsProcessDirectGasEmissionsCreateMutationBody = NonReadonly<ProcessDirectGasEmissionsRows>
    export type CompanyReportsImportsProcessDirectGasEmissionsCreateMutationError = unknown

    export const useCompanyReportsImportsProcessDirectGasEmissionsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsImportsProcessDirectGasEmissionsCreate>>, TError,{data: NonReadonly<ProcessDirectGasEmissionsRows>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsImportsProcessDirectGasEmissionsCreate>>,
        TError,
        {data: NonReadonly<ProcessDirectGasEmissionsRows>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsImportsProcessDirectGasEmissionsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Handles synchronous imports for electricity, heat, stationary-combustion,
mobile-combustion, and direct-gas-emissions. Accepts either a JSON body or
multipart/form-data with an optional uploaded_file (no RQ queue). Each row is
processed directly through the appropriate EmissionService, and the created
activity records are linked to the import. The entire batch is atomic — any
failure rolls back all rows.
 */
export const companyReportsImportsProcessElectricityCreate = (
    processElectricityRows: NonReadonly<ProcessElectricityRows>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ProcessElectricityRows>(
      {url: `/company-reports/imports/process/electricity`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
      data: processElectricityRows
    },
      options);
    }
  


export const getCompanyReportsImportsProcessElectricityCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsImportsProcessElectricityCreate>>, TError,{data: NonReadonly<ProcessElectricityRows>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsImportsProcessElectricityCreate>>, TError,{data: NonReadonly<ProcessElectricityRows>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsImportsProcessElectricityCreate>>, {data: NonReadonly<ProcessElectricityRows>}> = (props) => {
          const {data} = props ?? {};

          return  companyReportsImportsProcessElectricityCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsImportsProcessElectricityCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsImportsProcessElectricityCreate>>>
    export type CompanyReportsImportsProcessElectricityCreateMutationBody = NonReadonly<ProcessElectricityRows>
    export type CompanyReportsImportsProcessElectricityCreateMutationError = unknown

    export const useCompanyReportsImportsProcessElectricityCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsImportsProcessElectricityCreate>>, TError,{data: NonReadonly<ProcessElectricityRows>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsImportsProcessElectricityCreate>>,
        TError,
        {data: NonReadonly<ProcessElectricityRows>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsImportsProcessElectricityCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Handles synchronous imports for electricity, heat, stationary-combustion,
mobile-combustion, and direct-gas-emissions. Accepts either a JSON body or
multipart/form-data with an optional uploaded_file (no RQ queue). Each row is
processed directly through the appropriate EmissionService, and the created
activity records are linked to the import. The entire batch is atomic — any
failure rolls back all rows.
 */
export const companyReportsImportsProcessHeatCreate = (
    processHeatRows: NonReadonly<ProcessHeatRows>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ProcessHeatRows>(
      {url: `/company-reports/imports/process/heat`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
      data: processHeatRows
    },
      options);
    }
  


export const getCompanyReportsImportsProcessHeatCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsImportsProcessHeatCreate>>, TError,{data: NonReadonly<ProcessHeatRows>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsImportsProcessHeatCreate>>, TError,{data: NonReadonly<ProcessHeatRows>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsImportsProcessHeatCreate>>, {data: NonReadonly<ProcessHeatRows>}> = (props) => {
          const {data} = props ?? {};

          return  companyReportsImportsProcessHeatCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsImportsProcessHeatCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsImportsProcessHeatCreate>>>
    export type CompanyReportsImportsProcessHeatCreateMutationBody = NonReadonly<ProcessHeatRows>
    export type CompanyReportsImportsProcessHeatCreateMutationError = unknown

    export const useCompanyReportsImportsProcessHeatCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsImportsProcessHeatCreate>>, TError,{data: NonReadonly<ProcessHeatRows>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsImportsProcessHeatCreate>>,
        TError,
        {data: NonReadonly<ProcessHeatRows>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsImportsProcessHeatCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Handles synchronous imports for electricity, heat, stationary-combustion,
mobile-combustion, and direct-gas-emissions. Accepts either a JSON body or
multipart/form-data with an optional uploaded_file (no RQ queue). Each row is
processed directly through the appropriate EmissionService, and the created
activity records are linked to the import. The entire batch is atomic — any
failure rolls back all rows.
 */
export const companyReportsImportsProcessMobileCombustionCreate = (
    processMobileCombustionRows: NonReadonly<ProcessMobileCombustionRows>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ProcessMobileCombustionRows>(
      {url: `/company-reports/imports/process/mobile-combustion`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
      data: processMobileCombustionRows
    },
      options);
    }
  


export const getCompanyReportsImportsProcessMobileCombustionCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsImportsProcessMobileCombustionCreate>>, TError,{data: NonReadonly<ProcessMobileCombustionRows>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsImportsProcessMobileCombustionCreate>>, TError,{data: NonReadonly<ProcessMobileCombustionRows>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsImportsProcessMobileCombustionCreate>>, {data: NonReadonly<ProcessMobileCombustionRows>}> = (props) => {
          const {data} = props ?? {};

          return  companyReportsImportsProcessMobileCombustionCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsImportsProcessMobileCombustionCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsImportsProcessMobileCombustionCreate>>>
    export type CompanyReportsImportsProcessMobileCombustionCreateMutationBody = NonReadonly<ProcessMobileCombustionRows>
    export type CompanyReportsImportsProcessMobileCombustionCreateMutationError = unknown

    export const useCompanyReportsImportsProcessMobileCombustionCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsImportsProcessMobileCombustionCreate>>, TError,{data: NonReadonly<ProcessMobileCombustionRows>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsImportsProcessMobileCombustionCreate>>,
        TError,
        {data: NonReadonly<ProcessMobileCombustionRows>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsImportsProcessMobileCombustionCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Handles synchronous imports for electricity, heat, stationary-combustion,
mobile-combustion, and direct-gas-emissions. Accepts either a JSON body or
multipart/form-data with an optional uploaded_file (no RQ queue). Each row is
processed directly through the appropriate EmissionService, and the created
activity records are linked to the import. The entire batch is atomic — any
failure rolls back all rows.
 */
export const companyReportsImportsProcessStationaryCombustionCreate = (
    processStationaryCombustionRows: NonReadonly<ProcessStationaryCombustionRows>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ProcessStationaryCombustionRows>(
      {url: `/company-reports/imports/process/stationary-combustion`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
      data: processStationaryCombustionRows
    },
      options);
    }
  


export const getCompanyReportsImportsProcessStationaryCombustionCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsImportsProcessStationaryCombustionCreate>>, TError,{data: NonReadonly<ProcessStationaryCombustionRows>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsImportsProcessStationaryCombustionCreate>>, TError,{data: NonReadonly<ProcessStationaryCombustionRows>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsImportsProcessStationaryCombustionCreate>>, {data: NonReadonly<ProcessStationaryCombustionRows>}> = (props) => {
          const {data} = props ?? {};

          return  companyReportsImportsProcessStationaryCombustionCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsImportsProcessStationaryCombustionCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsImportsProcessStationaryCombustionCreate>>>
    export type CompanyReportsImportsProcessStationaryCombustionCreateMutationBody = NonReadonly<ProcessStationaryCombustionRows>
    export type CompanyReportsImportsProcessStationaryCombustionCreateMutationError = unknown

    export const useCompanyReportsImportsProcessStationaryCombustionCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsImportsProcessStationaryCombustionCreate>>, TError,{data: NonReadonly<ProcessStationaryCombustionRows>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsImportsProcessStationaryCombustionCreate>>,
        TError,
        {data: NonReadonly<ProcessStationaryCombustionRows>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsImportsProcessStationaryCombustionCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * List the imports that have not completed yet.
 */
export const activityImportsProgressList = (
    
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<ActivityImportProgress[]>(
      {url: `/company-reports/imports/progress`, method: 'GET', signal
    },
      options);
    }
  

export const getActivityImportsProgressListQueryKey = () => {
    return [`/company-reports/imports/progress`] as const;
    }

    
export const getActivityImportsProgressListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof activityImportsProgressList>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof activityImportsProgressList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityImportsProgressListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityImportsProgressList>>> = ({ signal }) => activityImportsProgressList(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof activityImportsProgressList>>, TError, TData> & { queryKey: QueryKey }
}

export type ActivityImportsProgressListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof activityImportsProgressList>>>
export type ActivityImportsProgressListInfiniteQueryError = unknown

export const useActivityImportsProgressListInfinite = <TData = Awaited<ReturnType<typeof activityImportsProgressList>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof activityImportsProgressList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getActivityImportsProgressListInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getActivityImportsProgressListQueryOptions = <TData = Awaited<ReturnType<typeof activityImportsProgressList>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof activityImportsProgressList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getActivityImportsProgressListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof activityImportsProgressList>>> = ({ signal }) => activityImportsProgressList(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof activityImportsProgressList>>, TError, TData> & { queryKey: QueryKey }
}

export type ActivityImportsProgressListQueryResult = NonNullable<Awaited<ReturnType<typeof activityImportsProgressList>>>
export type ActivityImportsProgressListQueryError = unknown

export const useActivityImportsProgressList = <TData = Awaited<ReturnType<typeof activityImportsProgressList>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof activityImportsProgressList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getActivityImportsProgressListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Streams a pre-populated Scope 1 & 2 data-collection workbook for the user's organisation.
 */
export const companyReportsImportsTemplateScope12Retrieve = (
    
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<Blob>(
      {url: `/company-reports/imports/template/scope-1-2`, method: 'GET',
        responseType: 'blob', signal
    },
      options);
    }
  

export const getCompanyReportsImportsTemplateScope12RetrieveQueryKey = () => {
    return [`/company-reports/imports/template/scope-1-2`] as const;
    }

    
export const getCompanyReportsImportsTemplateScope12RetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsImportsTemplateScope12Retrieve>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsImportsTemplateScope12Retrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsImportsTemplateScope12RetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsImportsTemplateScope12Retrieve>>> = ({ signal }) => companyReportsImportsTemplateScope12Retrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsImportsTemplateScope12Retrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsImportsTemplateScope12RetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsImportsTemplateScope12Retrieve>>>
export type CompanyReportsImportsTemplateScope12RetrieveInfiniteQueryError = unknown

export const useCompanyReportsImportsTemplateScope12RetrieveInfinite = <TData = Awaited<ReturnType<typeof companyReportsImportsTemplateScope12Retrieve>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsImportsTemplateScope12Retrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsImportsTemplateScope12RetrieveInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsImportsTemplateScope12RetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsImportsTemplateScope12Retrieve>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsImportsTemplateScope12Retrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsImportsTemplateScope12RetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsImportsTemplateScope12Retrieve>>> = ({ signal }) => companyReportsImportsTemplateScope12Retrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsImportsTemplateScope12Retrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsImportsTemplateScope12RetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsImportsTemplateScope12Retrieve>>>
export type CompanyReportsImportsTemplateScope12RetrieveQueryError = unknown

export const useCompanyReportsImportsTemplateScope12Retrieve = <TData = Awaited<ReturnType<typeof companyReportsImportsTemplateScope12Retrieve>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsImportsTemplateScope12Retrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsImportsTemplateScope12RetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsPackagingDefaultGroupsList = (
    
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<CCFPackagingGroup[]>(
      {url: `/company-reports/packaging/default-groups`, method: 'GET', signal
    },
      options);
    }
  

export const getCompanyReportsPackagingDefaultGroupsListQueryKey = () => {
    return [`/company-reports/packaging/default-groups`] as const;
    }

    
export const getCompanyReportsPackagingDefaultGroupsListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsPackagingDefaultGroupsList>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsPackagingDefaultGroupsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsPackagingDefaultGroupsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsPackagingDefaultGroupsList>>> = ({ signal }) => companyReportsPackagingDefaultGroupsList(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsPackagingDefaultGroupsList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsPackagingDefaultGroupsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsPackagingDefaultGroupsList>>>
export type CompanyReportsPackagingDefaultGroupsListInfiniteQueryError = unknown

export const useCompanyReportsPackagingDefaultGroupsListInfinite = <TData = Awaited<ReturnType<typeof companyReportsPackagingDefaultGroupsList>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsPackagingDefaultGroupsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsPackagingDefaultGroupsListInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsPackagingDefaultGroupsListQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsPackagingDefaultGroupsList>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsPackagingDefaultGroupsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsPackagingDefaultGroupsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsPackagingDefaultGroupsList>>> = ({ signal }) => companyReportsPackagingDefaultGroupsList(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsPackagingDefaultGroupsList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsPackagingDefaultGroupsListQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsPackagingDefaultGroupsList>>>
export type CompanyReportsPackagingDefaultGroupsListQueryError = unknown

export const useCompanyReportsPackagingDefaultGroupsList = <TData = Awaited<ReturnType<typeof companyReportsPackagingDefaultGroupsList>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsPackagingDefaultGroupsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsPackagingDefaultGroupsListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Lists passenger transport modes available for the user's country.

A mode is included if at least one ActivityEmissionFactor exists for it
at the site's country (or its continent fallback).
 */
export const companyReportsPassengerTransportModesList = (
    params?: CompanyReportsPassengerTransportModesListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PassengerTransportMode[]>(
      {url: `/company-reports/passenger-transport-modes`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCompanyReportsPassengerTransportModesListQueryKey = (params?: CompanyReportsPassengerTransportModesListParams,) => {
    return [`/company-reports/passenger-transport-modes`, ...(params ? [params]: [])] as const;
    }

    
export const getCompanyReportsPassengerTransportModesListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsPassengerTransportModesList>>, TError = unknown>(params?: CompanyReportsPassengerTransportModesListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsPassengerTransportModesList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsPassengerTransportModesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsPassengerTransportModesList>>> = ({ signal, pageParam }) => companyReportsPassengerTransportModesList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsPassengerTransportModesList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsPassengerTransportModesListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsPassengerTransportModesList>>>
export type CompanyReportsPassengerTransportModesListInfiniteQueryError = unknown

export const useCompanyReportsPassengerTransportModesListInfinite = <TData = Awaited<ReturnType<typeof companyReportsPassengerTransportModesList>>, TError = unknown>(
 params?: CompanyReportsPassengerTransportModesListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsPassengerTransportModesList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsPassengerTransportModesListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsPassengerTransportModesListQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsPassengerTransportModesList>>, TError = unknown>(params?: CompanyReportsPassengerTransportModesListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsPassengerTransportModesList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsPassengerTransportModesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsPassengerTransportModesList>>> = ({ signal }) => companyReportsPassengerTransportModesList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsPassengerTransportModesList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsPassengerTransportModesListQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsPassengerTransportModesList>>>
export type CompanyReportsPassengerTransportModesListQueryError = unknown

export const useCompanyReportsPassengerTransportModesList = <TData = Awaited<ReturnType<typeof companyReportsPassengerTransportModesList>>, TError = unknown>(
 params?: CompanyReportsPassengerTransportModesListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsPassengerTransportModesList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsPassengerTransportModesListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsSitesList = (
    params?: CompanyReportsSitesListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedSiteList>(
      {url: `/company-reports/sites`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCompanyReportsSitesListQueryKey = (params?: CompanyReportsSitesListParams,) => {
    return [`/company-reports/sites`, ...(params ? [params]: [])] as const;
    }

    
export const getCompanyReportsSitesListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsSitesList>>, TError = unknown>(params?: CompanyReportsSitesListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsSitesList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsSitesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsSitesList>>> = ({ signal, pageParam }) => companyReportsSitesList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsSitesList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsSitesListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsSitesList>>>
export type CompanyReportsSitesListInfiniteQueryError = unknown

export const useCompanyReportsSitesListInfinite = <TData = Awaited<ReturnType<typeof companyReportsSitesList>>, TError = unknown>(
 params?: CompanyReportsSitesListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsSitesList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsSitesListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsSitesListQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsSitesList>>, TError = unknown>(params?: CompanyReportsSitesListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsSitesList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsSitesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsSitesList>>> = ({ signal }) => companyReportsSitesList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsSitesList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsSitesListQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsSitesList>>>
export type CompanyReportsSitesListQueryError = unknown

export const useCompanyReportsSitesList = <TData = Awaited<ReturnType<typeof companyReportsSitesList>>, TError = unknown>(
 params?: CompanyReportsSitesListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsSitesList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsSitesListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsSitesCreate = (
    site: NonReadonly<Site>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<Site>(
      {url: `/company-reports/sites`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: site
    },
      options);
    }
  


export const getCompanyReportsSitesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSitesCreate>>, TError,{data: NonReadonly<Site>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsSitesCreate>>, TError,{data: NonReadonly<Site>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsSitesCreate>>, {data: NonReadonly<Site>}> = (props) => {
          const {data} = props ?? {};

          return  companyReportsSitesCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsSitesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsSitesCreate>>>
    export type CompanyReportsSitesCreateMutationBody = NonReadonly<Site>
    export type CompanyReportsSitesCreateMutationError = unknown

    export const useCompanyReportsSitesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSitesCreate>>, TError,{data: NonReadonly<Site>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsSitesCreate>>,
        TError,
        {data: NonReadonly<Site>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsSitesCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsSitesRetrieve = (
    uuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<Site>(
      {url: `/company-reports/sites/${uuid}`, method: 'GET', signal
    },
      options);
    }
  

export const getCompanyReportsSitesRetrieveQueryKey = (uuid: string,) => {
    return [`/company-reports/sites/${uuid}`] as const;
    }

    
export const getCompanyReportsSitesRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsSitesRetrieve>>, TError = unknown>(uuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsSitesRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsSitesRetrieveQueryKey(uuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsSitesRetrieve>>> = ({ signal }) => companyReportsSitesRetrieve(uuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(uuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsSitesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsSitesRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsSitesRetrieve>>>
export type CompanyReportsSitesRetrieveInfiniteQueryError = unknown

export const useCompanyReportsSitesRetrieveInfinite = <TData = Awaited<ReturnType<typeof companyReportsSitesRetrieve>>, TError = unknown>(
 uuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsSitesRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsSitesRetrieveInfiniteQueryOptions(uuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsSitesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsSitesRetrieve>>, TError = unknown>(uuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsSitesRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsSitesRetrieveQueryKey(uuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsSitesRetrieve>>> = ({ signal }) => companyReportsSitesRetrieve(uuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(uuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsSitesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsSitesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsSitesRetrieve>>>
export type CompanyReportsSitesRetrieveQueryError = unknown

export const useCompanyReportsSitesRetrieve = <TData = Awaited<ReturnType<typeof companyReportsSitesRetrieve>>, TError = unknown>(
 uuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsSitesRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsSitesRetrieveQueryOptions(uuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsSitesUpdate = (
    uuid: string,
    site: NonReadonly<Site>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<Site>(
      {url: `/company-reports/sites/${uuid}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: site
    },
      options);
    }
  


export const getCompanyReportsSitesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSitesUpdate>>, TError,{uuid: string;data: NonReadonly<Site>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsSitesUpdate>>, TError,{uuid: string;data: NonReadonly<Site>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsSitesUpdate>>, {uuid: string;data: NonReadonly<Site>}> = (props) => {
          const {uuid,data} = props ?? {};

          return  companyReportsSitesUpdate(uuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsSitesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsSitesUpdate>>>
    export type CompanyReportsSitesUpdateMutationBody = NonReadonly<Site>
    export type CompanyReportsSitesUpdateMutationError = unknown

    export const useCompanyReportsSitesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSitesUpdate>>, TError,{uuid: string;data: NonReadonly<Site>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsSitesUpdate>>,
        TError,
        {uuid: string;data: NonReadonly<Site>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsSitesUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsSitesPartialUpdate = (
    uuid: string,
    patchedSite: NonReadonly<PatchedSite>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<Site>(
      {url: `/company-reports/sites/${uuid}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedSite
    },
      options);
    }
  


export const getCompanyReportsSitesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSitesPartialUpdate>>, TError,{uuid: string;data: NonReadonly<PatchedSite>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsSitesPartialUpdate>>, TError,{uuid: string;data: NonReadonly<PatchedSite>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsSitesPartialUpdate>>, {uuid: string;data: NonReadonly<PatchedSite>}> = (props) => {
          const {uuid,data} = props ?? {};

          return  companyReportsSitesPartialUpdate(uuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsSitesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsSitesPartialUpdate>>>
    export type CompanyReportsSitesPartialUpdateMutationBody = NonReadonly<PatchedSite>
    export type CompanyReportsSitesPartialUpdateMutationError = unknown

    export const useCompanyReportsSitesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSitesPartialUpdate>>, TError,{uuid: string;data: NonReadonly<PatchedSite>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsSitesPartialUpdate>>,
        TError,
        {uuid: string;data: NonReadonly<PatchedSite>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsSitesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsSitesDestroy = (
    uuid: string,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<void>(
      {url: `/company-reports/sites/${uuid}`, method: 'DELETE'
    },
      options);
    }
  


export const getCompanyReportsSitesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSitesDestroy>>, TError,{uuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsSitesDestroy>>, TError,{uuid: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsSitesDestroy>>, {uuid: string}> = (props) => {
          const {uuid} = props ?? {};

          return  companyReportsSitesDestroy(uuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsSitesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsSitesDestroy>>>
    
    export type CompanyReportsSitesDestroyMutationError = unknown

    export const useCompanyReportsSitesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSitesDestroy>>, TError,{uuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsSitesDestroy>>,
        TError,
        {uuid: string},
        TContext
      > => {

      const mutationOptions = getCompanyReportsSitesDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsSitesBulkCreate = (
    site: NonReadonly<Site[]>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<Site[]>(
      {url: `/company-reports/sites/bulk`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: site
    },
      options);
    }
  


export const getCompanyReportsSitesBulkCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSitesBulkCreate>>, TError,{data: NonReadonly<Site[]>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsSitesBulkCreate>>, TError,{data: NonReadonly<Site[]>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsSitesBulkCreate>>, {data: NonReadonly<Site[]>}> = (props) => {
          const {data} = props ?? {};

          return  companyReportsSitesBulkCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsSitesBulkCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsSitesBulkCreate>>>
    export type CompanyReportsSitesBulkCreateMutationBody = NonReadonly<Site[]>
    export type CompanyReportsSitesBulkCreateMutationError = unknown

    export const useCompanyReportsSitesBulkCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSitesBulkCreate>>, TError,{data: NonReadonly<Site[]>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsSitesBulkCreate>>,
        TError,
        {data: NonReadonly<Site[]>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsSitesBulkCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsSitesElectricitySuppliesList = (
    params?: CompanyReportsSitesElectricitySuppliesListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedElectricitySupplyList>(
      {url: `/company-reports/sites/electricity-supplies`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCompanyReportsSitesElectricitySuppliesListQueryKey = (params?: CompanyReportsSitesElectricitySuppliesListParams,) => {
    return [`/company-reports/sites/electricity-supplies`, ...(params ? [params]: [])] as const;
    }

    
export const getCompanyReportsSitesElectricitySuppliesListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesList>>, TError = unknown>(params?: CompanyReportsSitesElectricitySuppliesListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsSitesElectricitySuppliesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesList>>> = ({ signal, pageParam }) => companyReportsSitesElectricitySuppliesList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsSitesElectricitySuppliesListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesList>>>
export type CompanyReportsSitesElectricitySuppliesListInfiniteQueryError = unknown

export const useCompanyReportsSitesElectricitySuppliesListInfinite = <TData = Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesList>>, TError = unknown>(
 params?: CompanyReportsSitesElectricitySuppliesListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsSitesElectricitySuppliesListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsSitesElectricitySuppliesListQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesList>>, TError = unknown>(params?: CompanyReportsSitesElectricitySuppliesListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsSitesElectricitySuppliesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesList>>> = ({ signal }) => companyReportsSitesElectricitySuppliesList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsSitesElectricitySuppliesListQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesList>>>
export type CompanyReportsSitesElectricitySuppliesListQueryError = unknown

export const useCompanyReportsSitesElectricitySuppliesList = <TData = Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesList>>, TError = unknown>(
 params?: CompanyReportsSitesElectricitySuppliesListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsSitesElectricitySuppliesListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsSitesElectricitySuppliesCreate = (
    electricitySupply: NonReadonly<ElectricitySupply>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ElectricitySupply>(
      {url: `/company-reports/sites/electricity-supplies`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: electricitySupply
    },
      options);
    }
  


export const getCompanyReportsSitesElectricitySuppliesCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesCreate>>, TError,{data: NonReadonly<ElectricitySupply>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesCreate>>, TError,{data: NonReadonly<ElectricitySupply>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesCreate>>, {data: NonReadonly<ElectricitySupply>}> = (props) => {
          const {data} = props ?? {};

          return  companyReportsSitesElectricitySuppliesCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsSitesElectricitySuppliesCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesCreate>>>
    export type CompanyReportsSitesElectricitySuppliesCreateMutationBody = NonReadonly<ElectricitySupply>
    export type CompanyReportsSitesElectricitySuppliesCreateMutationError = unknown

    export const useCompanyReportsSitesElectricitySuppliesCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesCreate>>, TError,{data: NonReadonly<ElectricitySupply>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesCreate>>,
        TError,
        {data: NonReadonly<ElectricitySupply>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsSitesElectricitySuppliesCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsSitesElectricitySuppliesRetrieve = (
    uuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<ElectricitySupply>(
      {url: `/company-reports/sites/electricity-supplies/${uuid}`, method: 'GET', signal
    },
      options);
    }
  

export const getCompanyReportsSitesElectricitySuppliesRetrieveQueryKey = (uuid: string,) => {
    return [`/company-reports/sites/electricity-supplies/${uuid}`] as const;
    }

    
export const getCompanyReportsSitesElectricitySuppliesRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesRetrieve>>, TError = unknown>(uuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsSitesElectricitySuppliesRetrieveQueryKey(uuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesRetrieve>>> = ({ signal }) => companyReportsSitesElectricitySuppliesRetrieve(uuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(uuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsSitesElectricitySuppliesRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesRetrieve>>>
export type CompanyReportsSitesElectricitySuppliesRetrieveInfiniteQueryError = unknown

export const useCompanyReportsSitesElectricitySuppliesRetrieveInfinite = <TData = Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesRetrieve>>, TError = unknown>(
 uuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsSitesElectricitySuppliesRetrieveInfiniteQueryOptions(uuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsSitesElectricitySuppliesRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesRetrieve>>, TError = unknown>(uuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsSitesElectricitySuppliesRetrieveQueryKey(uuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesRetrieve>>> = ({ signal }) => companyReportsSitesElectricitySuppliesRetrieve(uuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(uuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsSitesElectricitySuppliesRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesRetrieve>>>
export type CompanyReportsSitesElectricitySuppliesRetrieveQueryError = unknown

export const useCompanyReportsSitesElectricitySuppliesRetrieve = <TData = Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesRetrieve>>, TError = unknown>(
 uuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsSitesElectricitySuppliesRetrieveQueryOptions(uuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsSitesElectricitySuppliesUpdate = (
    uuid: string,
    electricitySupply: NonReadonly<ElectricitySupply>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ElectricitySupply>(
      {url: `/company-reports/sites/electricity-supplies/${uuid}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: electricitySupply
    },
      options);
    }
  


export const getCompanyReportsSitesElectricitySuppliesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesUpdate>>, TError,{uuid: string;data: NonReadonly<ElectricitySupply>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesUpdate>>, TError,{uuid: string;data: NonReadonly<ElectricitySupply>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesUpdate>>, {uuid: string;data: NonReadonly<ElectricitySupply>}> = (props) => {
          const {uuid,data} = props ?? {};

          return  companyReportsSitesElectricitySuppliesUpdate(uuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsSitesElectricitySuppliesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesUpdate>>>
    export type CompanyReportsSitesElectricitySuppliesUpdateMutationBody = NonReadonly<ElectricitySupply>
    export type CompanyReportsSitesElectricitySuppliesUpdateMutationError = unknown

    export const useCompanyReportsSitesElectricitySuppliesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesUpdate>>, TError,{uuid: string;data: NonReadonly<ElectricitySupply>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesUpdate>>,
        TError,
        {uuid: string;data: NonReadonly<ElectricitySupply>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsSitesElectricitySuppliesUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsSitesElectricitySuppliesPartialUpdate = (
    uuid: string,
    patchedElectricitySupply: NonReadonly<PatchedElectricitySupply>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<ElectricitySupply>(
      {url: `/company-reports/sites/electricity-supplies/${uuid}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedElectricitySupply
    },
      options);
    }
  


export const getCompanyReportsSitesElectricitySuppliesPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesPartialUpdate>>, TError,{uuid: string;data: NonReadonly<PatchedElectricitySupply>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesPartialUpdate>>, TError,{uuid: string;data: NonReadonly<PatchedElectricitySupply>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesPartialUpdate>>, {uuid: string;data: NonReadonly<PatchedElectricitySupply>}> = (props) => {
          const {uuid,data} = props ?? {};

          return  companyReportsSitesElectricitySuppliesPartialUpdate(uuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsSitesElectricitySuppliesPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesPartialUpdate>>>
    export type CompanyReportsSitesElectricitySuppliesPartialUpdateMutationBody = NonReadonly<PatchedElectricitySupply>
    export type CompanyReportsSitesElectricitySuppliesPartialUpdateMutationError = unknown

    export const useCompanyReportsSitesElectricitySuppliesPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesPartialUpdate>>, TError,{uuid: string;data: NonReadonly<PatchedElectricitySupply>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesPartialUpdate>>,
        TError,
        {uuid: string;data: NonReadonly<PatchedElectricitySupply>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsSitesElectricitySuppliesPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsSitesElectricitySuppliesDestroy = (
    uuid: string,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<void>(
      {url: `/company-reports/sites/electricity-supplies/${uuid}`, method: 'DELETE'
    },
      options);
    }
  


export const getCompanyReportsSitesElectricitySuppliesDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesDestroy>>, TError,{uuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesDestroy>>, TError,{uuid: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesDestroy>>, {uuid: string}> = (props) => {
          const {uuid} = props ?? {};

          return  companyReportsSitesElectricitySuppliesDestroy(uuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsSitesElectricitySuppliesDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesDestroy>>>
    
    export type CompanyReportsSitesElectricitySuppliesDestroyMutationError = unknown

    export const useCompanyReportsSitesElectricitySuppliesDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesDestroy>>, TError,{uuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsSitesElectricitySuppliesDestroy>>,
        TError,
        {uuid: string},
        TContext
      > => {

      const mutationOptions = getCompanyReportsSitesElectricitySuppliesDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * GET: Returns list of all logistics flows with their stages
POST: Creates a new logistics flow with the provided stages
 */
export const companyReportsSupplyChainLogisticsFlowList = (
    params?: CompanyReportsSupplyChainLogisticsFlowListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedLogisticsFlowListList>(
      {url: `/company-reports/supply-chain/logistics-flow`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCompanyReportsSupplyChainLogisticsFlowListQueryKey = (params?: CompanyReportsSupplyChainLogisticsFlowListParams,) => {
    return [`/company-reports/supply-chain/logistics-flow`, ...(params ? [params]: [])] as const;
    }

    
export const getCompanyReportsSupplyChainLogisticsFlowListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowList>>, TError = unknown>(params?: CompanyReportsSupplyChainLogisticsFlowListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsSupplyChainLogisticsFlowListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowList>>> = ({ signal, pageParam }) => companyReportsSupplyChainLogisticsFlowList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsSupplyChainLogisticsFlowListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowList>>>
export type CompanyReportsSupplyChainLogisticsFlowListInfiniteQueryError = unknown

export const useCompanyReportsSupplyChainLogisticsFlowListInfinite = <TData = Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowList>>, TError = unknown>(
 params?: CompanyReportsSupplyChainLogisticsFlowListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsSupplyChainLogisticsFlowListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsSupplyChainLogisticsFlowListQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowList>>, TError = unknown>(params?: CompanyReportsSupplyChainLogisticsFlowListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsSupplyChainLogisticsFlowListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowList>>> = ({ signal }) => companyReportsSupplyChainLogisticsFlowList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsSupplyChainLogisticsFlowListQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowList>>>
export type CompanyReportsSupplyChainLogisticsFlowListQueryError = unknown

export const useCompanyReportsSupplyChainLogisticsFlowList = <TData = Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowList>>, TError = unknown>(
 params?: CompanyReportsSupplyChainLogisticsFlowListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsSupplyChainLogisticsFlowListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * GET: Returns list of all logistics flows with their stages
POST: Creates a new logistics flow with the provided stages
 */
export const companyReportsSupplyChainLogisticsFlowCreate = (
    logisticsFlowCreate: LogisticsFlowCreate,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<LogisticsFlowDetail>(
      {url: `/company-reports/supply-chain/logistics-flow`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: logisticsFlowCreate
    },
      options);
    }
  


export const getCompanyReportsSupplyChainLogisticsFlowCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowCreate>>, TError,{data: LogisticsFlowCreate}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowCreate>>, TError,{data: LogisticsFlowCreate}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowCreate>>, {data: LogisticsFlowCreate}> = (props) => {
          const {data} = props ?? {};

          return  companyReportsSupplyChainLogisticsFlowCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsSupplyChainLogisticsFlowCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowCreate>>>
    export type CompanyReportsSupplyChainLogisticsFlowCreateMutationBody = LogisticsFlowCreate
    export type CompanyReportsSupplyChainLogisticsFlowCreateMutationError = unknown

    export const useCompanyReportsSupplyChainLogisticsFlowCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowCreate>>, TError,{data: LogisticsFlowCreate}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowCreate>>,
        TError,
        {data: LogisticsFlowCreate},
        TContext
      > => {

      const mutationOptions = getCompanyReportsSupplyChainLogisticsFlowCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * GET: Returns a single logistics flow with all its stages
PUT: Updates an existing logistics flow with the provided stages
DELETE: Deletes an existing logistics flow
 */
export const companyReportsSupplyChainLogisticsFlowRetrieve = (
    logisticsFlowUuid: string,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<LogisticsFlowDetail>(
      {url: `/company-reports/supply-chain/logistics-flow/${logisticsFlowUuid}`, method: 'GET', signal
    },
      options);
    }
  

export const getCompanyReportsSupplyChainLogisticsFlowRetrieveQueryKey = (logisticsFlowUuid: string,) => {
    return [`/company-reports/supply-chain/logistics-flow/${logisticsFlowUuid}`] as const;
    }

    
export const getCompanyReportsSupplyChainLogisticsFlowRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowRetrieve>>, TError = unknown>(logisticsFlowUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsSupplyChainLogisticsFlowRetrieveQueryKey(logisticsFlowUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowRetrieve>>> = ({ signal }) => companyReportsSupplyChainLogisticsFlowRetrieve(logisticsFlowUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(logisticsFlowUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsSupplyChainLogisticsFlowRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowRetrieve>>>
export type CompanyReportsSupplyChainLogisticsFlowRetrieveInfiniteQueryError = unknown

export const useCompanyReportsSupplyChainLogisticsFlowRetrieveInfinite = <TData = Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowRetrieve>>, TError = unknown>(
 logisticsFlowUuid: string, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsSupplyChainLogisticsFlowRetrieveInfiniteQueryOptions(logisticsFlowUuid,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsSupplyChainLogisticsFlowRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowRetrieve>>, TError = unknown>(logisticsFlowUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsSupplyChainLogisticsFlowRetrieveQueryKey(logisticsFlowUuid);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowRetrieve>>> = ({ signal }) => companyReportsSupplyChainLogisticsFlowRetrieve(logisticsFlowUuid, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(logisticsFlowUuid),  refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsSupplyChainLogisticsFlowRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowRetrieve>>>
export type CompanyReportsSupplyChainLogisticsFlowRetrieveQueryError = unknown

export const useCompanyReportsSupplyChainLogisticsFlowRetrieve = <TData = Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowRetrieve>>, TError = unknown>(
 logisticsFlowUuid: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsSupplyChainLogisticsFlowRetrieveQueryOptions(logisticsFlowUuid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * GET: Returns a single logistics flow with all its stages
PUT: Updates an existing logistics flow with the provided stages
DELETE: Deletes an existing logistics flow
 */
export const companyReportsSupplyChainLogisticsFlowUpdate = (
    logisticsFlowUuid: string,
    logisticsFlowUpdate: LogisticsFlowUpdate,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<LogisticsFlowUpdate>(
      {url: `/company-reports/supply-chain/logistics-flow/${logisticsFlowUuid}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: logisticsFlowUpdate
    },
      options);
    }
  


export const getCompanyReportsSupplyChainLogisticsFlowUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowUpdate>>, TError,{logisticsFlowUuid: string;data: LogisticsFlowUpdate}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowUpdate>>, TError,{logisticsFlowUuid: string;data: LogisticsFlowUpdate}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowUpdate>>, {logisticsFlowUuid: string;data: LogisticsFlowUpdate}> = (props) => {
          const {logisticsFlowUuid,data} = props ?? {};

          return  companyReportsSupplyChainLogisticsFlowUpdate(logisticsFlowUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsSupplyChainLogisticsFlowUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowUpdate>>>
    export type CompanyReportsSupplyChainLogisticsFlowUpdateMutationBody = LogisticsFlowUpdate
    export type CompanyReportsSupplyChainLogisticsFlowUpdateMutationError = unknown

    export const useCompanyReportsSupplyChainLogisticsFlowUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowUpdate>>, TError,{logisticsFlowUuid: string;data: LogisticsFlowUpdate}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowUpdate>>,
        TError,
        {logisticsFlowUuid: string;data: LogisticsFlowUpdate},
        TContext
      > => {

      const mutationOptions = getCompanyReportsSupplyChainLogisticsFlowUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * GET: Returns a single logistics flow with all its stages
PUT: Updates an existing logistics flow with the provided stages
DELETE: Deletes an existing logistics flow
 */
export const companyReportsSupplyChainLogisticsFlowPartialUpdate = (
    logisticsFlowUuid: string,
    patchedLogisticsFlowDetail: NonReadonly<PatchedLogisticsFlowDetail>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<LogisticsFlowDetail>(
      {url: `/company-reports/supply-chain/logistics-flow/${logisticsFlowUuid}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: patchedLogisticsFlowDetail
    },
      options);
    }
  


export const getCompanyReportsSupplyChainLogisticsFlowPartialUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowPartialUpdate>>, TError,{logisticsFlowUuid: string;data: NonReadonly<PatchedLogisticsFlowDetail>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowPartialUpdate>>, TError,{logisticsFlowUuid: string;data: NonReadonly<PatchedLogisticsFlowDetail>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowPartialUpdate>>, {logisticsFlowUuid: string;data: NonReadonly<PatchedLogisticsFlowDetail>}> = (props) => {
          const {logisticsFlowUuid,data} = props ?? {};

          return  companyReportsSupplyChainLogisticsFlowPartialUpdate(logisticsFlowUuid,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsSupplyChainLogisticsFlowPartialUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowPartialUpdate>>>
    export type CompanyReportsSupplyChainLogisticsFlowPartialUpdateMutationBody = NonReadonly<PatchedLogisticsFlowDetail>
    export type CompanyReportsSupplyChainLogisticsFlowPartialUpdateMutationError = unknown

    export const useCompanyReportsSupplyChainLogisticsFlowPartialUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowPartialUpdate>>, TError,{logisticsFlowUuid: string;data: NonReadonly<PatchedLogisticsFlowDetail>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowPartialUpdate>>,
        TError,
        {logisticsFlowUuid: string;data: NonReadonly<PatchedLogisticsFlowDetail>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsSupplyChainLogisticsFlowPartialUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * GET: Returns a single logistics flow with all its stages
PUT: Updates an existing logistics flow with the provided stages
DELETE: Deletes an existing logistics flow
 */
export const companyReportsSupplyChainLogisticsFlowDestroy = (
    logisticsFlowUuid: string,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<void>(
      {url: `/company-reports/supply-chain/logistics-flow/${logisticsFlowUuid}`, method: 'DELETE'
    },
      options);
    }
  


export const getCompanyReportsSupplyChainLogisticsFlowDestroyMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowDestroy>>, TError,{logisticsFlowUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowDestroy>>, TError,{logisticsFlowUuid: string}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowDestroy>>, {logisticsFlowUuid: string}> = (props) => {
          const {logisticsFlowUuid} = props ?? {};

          return  companyReportsSupplyChainLogisticsFlowDestroy(logisticsFlowUuid,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsSupplyChainLogisticsFlowDestroyMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowDestroy>>>
    
    export type CompanyReportsSupplyChainLogisticsFlowDestroyMutationError = unknown

    export const useCompanyReportsSupplyChainLogisticsFlowDestroy = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowDestroy>>, TError,{logisticsFlowUuid: string}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowDestroy>>,
        TError,
        {logisticsFlowUuid: string},
        TContext
      > => {

      const mutationOptions = getCompanyReportsSupplyChainLogisticsFlowDestroyMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Return template data based on the provided parameters
 */
export const companyReportsSupplyChainLogisticsFlowTemplateCreate = (
    logisticsFlowTemplate: NonReadonly<LogisticsFlowTemplate>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<LogisticsFlowTemplate>(
      {url: `/company-reports/supply-chain/logistics-flow/template`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: logisticsFlowTemplate
    },
      options);
    }
  


export const getCompanyReportsSupplyChainLogisticsFlowTemplateCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowTemplateCreate>>, TError,{data: NonReadonly<LogisticsFlowTemplate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowTemplateCreate>>, TError,{data: NonReadonly<LogisticsFlowTemplate>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowTemplateCreate>>, {data: NonReadonly<LogisticsFlowTemplate>}> = (props) => {
          const {data} = props ?? {};

          return  companyReportsSupplyChainLogisticsFlowTemplateCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsSupplyChainLogisticsFlowTemplateCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowTemplateCreate>>>
    export type CompanyReportsSupplyChainLogisticsFlowTemplateCreateMutationBody = NonReadonly<LogisticsFlowTemplate>
    export type CompanyReportsSupplyChainLogisticsFlowTemplateCreateMutationError = unknown

    export const useCompanyReportsSupplyChainLogisticsFlowTemplateCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowTemplateCreate>>, TError,{data: NonReadonly<LogisticsFlowTemplate>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsSupplyChainLogisticsFlowTemplateCreate>>,
        TError,
        {data: NonReadonly<LogisticsFlowTemplate>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsSupplyChainLogisticsFlowTemplateCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const companyReportsTagsList = (
    
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<Tag[]>(
      {url: `/company-reports/tags`, method: 'GET', signal
    },
      options);
    }
  

export const getCompanyReportsTagsListQueryKey = () => {
    return [`/company-reports/tags`] as const;
    }

    
export const getCompanyReportsTagsListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsTagsList>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsTagsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsTagsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsTagsList>>> = ({ signal }) => companyReportsTagsList(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsTagsList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsTagsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsTagsList>>>
export type CompanyReportsTagsListInfiniteQueryError = unknown

export const useCompanyReportsTagsListInfinite = <TData = Awaited<ReturnType<typeof companyReportsTagsList>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsTagsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsTagsListInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsTagsListQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsTagsList>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsTagsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsTagsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsTagsList>>> = ({ signal }) => companyReportsTagsList(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsTagsList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsTagsListQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsTagsList>>>
export type CompanyReportsTagsListQueryError = unknown

export const useCompanyReportsTagsList = <TData = Awaited<ReturnType<typeof companyReportsTagsList>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsTagsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsTagsListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const companyReportsTagsCreate = (
    tag: NonReadonly<Tag>,
 options?: SecondParameter<typeof apiClient>,) => {
      
      
      return apiClient<Tag>(
      {url: `/company-reports/tags`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: tag
    },
      options);
    }
  


export const getCompanyReportsTagsCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsTagsCreate>>, TError,{data: NonReadonly<Tag>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationOptions<Awaited<ReturnType<typeof companyReportsTagsCreate>>, TError,{data: NonReadonly<Tag>}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof companyReportsTagsCreate>>, {data: NonReadonly<Tag>}> = (props) => {
          const {data} = props ?? {};

          return  companyReportsTagsCreate(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CompanyReportsTagsCreateMutationResult = NonNullable<Awaited<ReturnType<typeof companyReportsTagsCreate>>>
    export type CompanyReportsTagsCreateMutationBody = NonReadonly<Tag>
    export type CompanyReportsTagsCreateMutationError = unknown

    export const useCompanyReportsTagsCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof companyReportsTagsCreate>>, TError,{data: NonReadonly<Tag>}, TContext>, request?: SecondParameter<typeof apiClient>}
): UseMutationResult<
        Awaited<ReturnType<typeof companyReportsTagsCreate>>,
        TError,
        {data: NonReadonly<Tag>},
        TContext
      > => {

      const mutationOptions = getCompanyReportsTagsCreateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const organizationTimePeriodsList = (
    
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<TimePeriod[]>(
      {url: `/company-reports/time-periods`, method: 'GET', signal
    },
      options);
    }
  

export const getOrganizationTimePeriodsListQueryKey = () => {
    return [`/company-reports/time-periods`] as const;
    }

    
export const getOrganizationTimePeriodsListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof organizationTimePeriodsList>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof organizationTimePeriodsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationTimePeriodsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationTimePeriodsList>>> = ({ signal }) => organizationTimePeriodsList(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof organizationTimePeriodsList>>, TError, TData> & { queryKey: QueryKey }
}

export type OrganizationTimePeriodsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof organizationTimePeriodsList>>>
export type OrganizationTimePeriodsListInfiniteQueryError = unknown

export const useOrganizationTimePeriodsListInfinite = <TData = Awaited<ReturnType<typeof organizationTimePeriodsList>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof organizationTimePeriodsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getOrganizationTimePeriodsListInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getOrganizationTimePeriodsListQueryOptions = <TData = Awaited<ReturnType<typeof organizationTimePeriodsList>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof organizationTimePeriodsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getOrganizationTimePeriodsListQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof organizationTimePeriodsList>>> = ({ signal }) => organizationTimePeriodsList(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof organizationTimePeriodsList>>, TError, TData> & { queryKey: QueryKey }
}

export type OrganizationTimePeriodsListQueryResult = NonNullable<Awaited<ReturnType<typeof organizationTimePeriodsList>>>
export type OrganizationTimePeriodsListQueryError = unknown

export const useOrganizationTimePeriodsList = <TData = Awaited<ReturnType<typeof organizationTimePeriodsList>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof organizationTimePeriodsList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getOrganizationTimePeriodsListQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * List available transport modes.

GET: Returns list of all available transport modes
 */
export const companyReportsTransportModesList = (
    params?: CompanyReportsTransportModesListParams,
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<PaginatedSupplyChainTransportModeList>(
      {url: `/company-reports/transport-modes`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCompanyReportsTransportModesListQueryKey = (params?: CompanyReportsTransportModesListParams,) => {
    return [`/company-reports/transport-modes`, ...(params ? [params]: [])] as const;
    }

    
export const getCompanyReportsTransportModesListInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsTransportModesList>>, TError = unknown>(params?: CompanyReportsTransportModesListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsTransportModesList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsTransportModesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsTransportModesList>>> = ({ signal, pageParam }) => companyReportsTransportModesList({...params, page: pageParam || params?.['page']}, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsTransportModesList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsTransportModesListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsTransportModesList>>>
export type CompanyReportsTransportModesListInfiniteQueryError = unknown

export const useCompanyReportsTransportModesListInfinite = <TData = Awaited<ReturnType<typeof companyReportsTransportModesList>>, TError = unknown>(
 params?: CompanyReportsTransportModesListParams, options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsTransportModesList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsTransportModesListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsTransportModesListQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsTransportModesList>>, TError = unknown>(params?: CompanyReportsTransportModesListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsTransportModesList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsTransportModesListQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsTransportModesList>>> = ({ signal }) => companyReportsTransportModesList(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsTransportModesList>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsTransportModesListQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsTransportModesList>>>
export type CompanyReportsTransportModesListQueryError = unknown

export const useCompanyReportsTransportModesList = <TData = Awaited<ReturnType<typeof companyReportsTransportModesList>>, TError = unknown>(
 params?: CompanyReportsTransportModesListParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsTransportModesList>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsTransportModesListQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get available reporting years for the organization.

Returns:
- Starting earliest Jan 2021 (could be dynamic based on geography in the future)
- Running up to the most recent year where the start date would not be in the future
- Ordered in reverse chronological order
- Excludes or marks unavailable options for which a report has already been created
 */
export const companyReportsValidReportingYearsRetrieve = (
    
 options?: SecondParameter<typeof apiClient>,signal?: AbortSignal
) => {
      
      
      return apiClient<ReportingYear>(
      {url: `/company-reports/valid-reporting-years`, method: 'GET', signal
    },
      options);
    }
  

export const getCompanyReportsValidReportingYearsRetrieveQueryKey = () => {
    return [`/company-reports/valid-reporting-years`] as const;
    }

    
export const getCompanyReportsValidReportingYearsRetrieveInfiniteQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsValidReportingYearsRetrieve>>, TError = unknown>( options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsValidReportingYearsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsValidReportingYearsRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsValidReportingYearsRetrieve>>> = ({ signal }) => companyReportsValidReportingYearsRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsValidReportingYearsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsValidReportingYearsRetrieveInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsValidReportingYearsRetrieve>>>
export type CompanyReportsValidReportingYearsRetrieveInfiniteQueryError = unknown

export const useCompanyReportsValidReportingYearsRetrieveInfinite = <TData = Awaited<ReturnType<typeof companyReportsValidReportingYearsRetrieve>>, TError = unknown>(
  options?: { query?:UseInfiniteQueryOptions<Awaited<ReturnType<typeof companyReportsValidReportingYearsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsValidReportingYearsRetrieveInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions) as  UseInfiniteQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCompanyReportsValidReportingYearsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof companyReportsValidReportingYearsRetrieve>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsValidReportingYearsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCompanyReportsValidReportingYearsRetrieveQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof companyReportsValidReportingYearsRetrieve>>> = ({ signal }) => companyReportsValidReportingYearsRetrieve(requestOptions, signal);

      

      

   return  { queryKey, queryFn,   refetchOnWindowFocus: false, retry: 1,  ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof companyReportsValidReportingYearsRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CompanyReportsValidReportingYearsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof companyReportsValidReportingYearsRetrieve>>>
export type CompanyReportsValidReportingYearsRetrieveQueryError = unknown

export const useCompanyReportsValidReportingYearsRetrieve = <TData = Awaited<ReturnType<typeof companyReportsValidReportingYearsRetrieve>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof companyReportsValidReportingYearsRetrieve>>, TError, TData>, request?: SecondParameter<typeof apiClient>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCompanyReportsValidReportingYearsRetrieveQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



